export const talukasByDistrict = {
    "Anantapur": [
        "Agali",
        "Amadagur",
        "Amarapuram",
        "Anantapur",
        "Atmakur",
        "Bathalapalle",
        "Beluguppa",
        "Bommanahal",
        "Brahmasamudram",
        "Bukkapatnam",
        "Bukkaraya Samudram",
        "Chennekothapalle",
        "Chilamathur",
        "D.hirehal",
        "Dharmavaram",
        "Gandlapenta",
        "Garladinne",
        "Gooty",
        "Gorantla",
        "Gudibanda",
        "Gummagatta",
        "Guntakal",
        "Hindupur",
        "Kadiri",
        "Kalyandurg",
        "Kambadur",
        "Kanaganapalle",
        "Kanekal",
        "Kothacheruvu",
        "Kudair",
        "Kundurpi",
        "Lepakshi",
        "Madakasira",
        "Mudigubba",
        "Nallacheruvu",
        "Nallamada",
        "Nambulipulikunta",
        "Narpala",
        "Obuladevaracheruvu",
        "Pamidi",
        "Parigi",
        "Peddapappur",
        "Peddavadugur",
        "Penukonda",
        "Putlur",
        "Puttaparthi",
        "Ramagiri",
        "Raptadu",
        "Rayadurg",
        "Roddam",
        "Rolla",
        "Settur",
        "Singanamala",
        "Somandepalle",
        "Tadimarri",
        "Tadpatri",
        "Talupula",
        "Tanakal",
        "Uravakonda",
        "Vajrakarur",
        "Vidapanakal",
        "Yadiki",
        "Yellanur"
    ],
    "Chittoor": [
        "B.kothakota",
        "Baireddipalle",
        "Bangarupalem",
        "Buchinaidu Kandriga",
        "Chandragiri",
        "Chinnagottigallu",
        "Chittoor",
        "Chowdepalle",
        "Gangadhara Nellore",
        "Gangavaram",
        "Gudipala",
        "Gudupalle",
        "Gurramkonda",
        "Irala",
        "K.v.b.puram",
        "Kalakada",
        "Kalikiri",
        "Kambhamvaripalle",
        "Karvetinagar",
        "Kuppam",
        "Kurabalakota",
        "Madanapalle",
        "Mulakalacheruvu",
        "Nagalapuram",
        "Nagari",
        "Narayanavanam",
        "Nimmanapalle",
        "Nindra",
        "Pakala",
        "Palamaner",
        "Palasamudram",
        "Pedda Thippasamudram",
        "Peddamandyam",
        "Peddapanjani",
        "Penumuru",
        "Pichatur",
        "Pileru",
        "Pulicherla",
        "Punganur",
        "Puthalapattu",
        "Puttur",
        "Ramachandrapuram",
        "Ramakuppam",
        "Ramasamudram",
        "Renigunta",
        "Rompicherla",
        "Santhipuram",
        "Satyavedu",
        "Sodam",
        "Somala",
        "Srikalahasti",
        "Srirangarajapuram",
        "Thamballapalle",
        "Thavanampalle",
        "Thottambedu",
        "Tirupati (rural)",
        "Tirupati (urban)",
        "Vadamalapeta",
        "Valmikipuram",
        "Varadaiahpalem",
        "Vayalpad",
        "Vedurukuppam",
        "Venkatagirikota",
        "Vijayapuram",
        "Yadamarri",
        "Yerpedu",
        "Yerravaripalem"
    ],
    "Guntur": [
        "Amaravathi",
        "Amruthalur",
        "Atchampet",
        "Bapatla",
        "Bellamkonda",
        "Bhattiprolu",
        "Bollapalle",
        "Chebrolu",
        "Cherukupalle H/o Arumbaka",
        "Chilakaluripet",
        "Dachepalle",
        "Duggirala",
        "Durgi",
        "Edlapadu",
        "Guntur",
        "Gurazala",
        "Ipur",
        "Kakumanu",
        "Karempudi",
        "Karlapalem",
        "Kollipara",
        "Kollur",
        "Krosuru",
        "Machavaram",
        "Macherla",
        "Mangalagiri",
        "Medikonduru",
        "Muppalla",
        "Nadendla",
        "Nagaram",
        "Narasaraopet",
        "Nekarikallu",
        "Nizampatnam",
        "Nuzendla",
        "Pedakakani",
        "Pedakurapadu",
        "Pedanandipadu",
        "Phirangipuram",
        "Piduguralla",
        "Pittalavanipalem",
        "Ponnur",
        "Prathipadu",
        "Rajupalem",
        "Rentachintala",
        "Repalle",
        "Rompicherla",
        "Sattenapalle",
        "Savalyapuram H/o Kanamarlapudi",
        "Tadepalle",
        "Tadikonda",
        "Tenali",
        "Thullur",
        "Tsundur",
        "Vatticherukuru",
        "Veldurthi",
        "Vemuru",
        "Vinukonda"
    ],
    "Krishna": [
        "Adoni",
        "Allagadda",
        "Alur",
        "Aspari",
        "Atmakur",
        "Banaganapalle",
        "Bandi Atmakur",
        "Bethamcherla",
        "C.belagal",
        "Chagalamarri",
        "Chippagiri",
        "Devanakonda",
        "Dhone",
        "Dornipadu",
        "Gadivemula",
        "Gonegandla",
        "Gospadu",
        "Gudur",
        "Halaharvi",
        "Holagunda",
        "Jupadu Bungalow",
        "Kallur",
        "Kodumur",
        "Koilkuntla",
        "Kolimigundla",
        "Kosigi",
        "Kothapalle",
        "Kowthalam",
        "Krishnagiri",
        "Kurnool",
        "Maddikera (east)",
        "Mahanandi",
        "Mantralayam",
        "Midthur",
        "Nandavaram",
        "Nandikotkur",
        "Nandyal",
        "Orvakal",
        "Owk",
        "Pagidyala",
        "Pamulapadu",
        "Panyam",
        "Pattikonda",
        "Peapally",
        "Pedda Kadubur",
        "Rudravaram",
        "Sanjamala",
        "Sirvel",
        "Srisailam",
        "Tuggali",
        "Uyyalawada",
        "Veldurthi",
        "Velgode",
        "Yemmiganur"
    ],
    "Kurnool": [
        "Adoni",
        "Allagadda",
        "Alur",
        "Aspari",
        "Atmakur",
        "Banaganapalle",
        "Bandi Atmakur",
        "Bethamcherla",
        "C.belagal",
        "Chagalamarri",
        "Chippagiri",
        "Devanakonda",
        "Dhone",
        "Dornipadu",
        "Gadivemula",
        "Gonegandla",
        "Gospadu",
        "Gudur",
        "Halaharvi",
        "Holagunda",
        "Jupadu Bungalow",
        "Kallur",
        "Kodumur",
        "Koilkuntla",
        "Kolimigundla",
        "Kosigi",
        "Kothapalle",
        "Kowthalam",
        "Krishnagiri",
        "Kurnool",
        "Maddikera (east)",
        "Mahanandi",
        "Mantralayam",
        "Midthur",
        "Nandavaram",
        "Nandikotkur",
        "Nandyal",
        "Orvakal",
        "Owk",
        "Pagidyala",
        "Pamulapadu",
        "Panyam",
        "Pattikonda",
        "Peapally",
        "Pedda Kadubur",
        "Rudravaram",
        "Sanjamala",
        "Sirvel",
        "Srisailam",
        "Tuggali",
        "Uyyalawada",
        "Veldurthi",
        "Velgode",
        "Yemmiganur"
    ],
    "Nellore": [
        "Allur",
        "Ananthasagaram",
        "Anumasamudrampeta",
        "Atmakur",
        "Balayapalle",
        "Bogole",
        "Buchireddipalem",
        "Chejerla",
        "Chillakur",
        "Chittamur",
        "Dagadarthi",
        "Dakkili",
        "Doravarisatram",
        "Duttalur",
        "Gudur",
        "Indukurpet",
        "Jaladanki",
        "Kaligiri",
        "Kaluvoya",
        "Kavali",
        "Kodavalur",
        "Kondapuram",
        "Kota",
        "Kovur",
        "Manubolu",
        "Marripadu",
        "Muthukur",
        "Naidupet",
        "Nellore",
        "Ojili",
        "Pellakur",
        "Podalakur",
        "Rapur",
        "Sangam",
        "Seetharamapuram",
        "Sullurpeta",
        "Sydapuram",
        "Tada",
        "Thotapalligudur",
        "Udayagiri",
        "Vakadu",
        "Varikuntapadu",
        "Venkatachalam",
        "Venkatagiri",
        "Vidavalur",
        "Vinjamur"
    ],
    "Srikakulam": [
        "Amadalavalasa",
        "Bhamini",
        "Burja",
        "Etcherla",
        "Ganguvarisigadam",
        "Gara",
        "Hiramandalam",
        "Ichchapuram",
        "Jalumuru",
        "Kanchili",
        "Kaviti",
        "Kotabommali",
        "Kothuru",
        "Lakshminarsupeta",
        "Laveru",
        "Mandasa",
        "Meliaputti",
        "Nandigam",
        "Narasannapeta",
        "Palakonda",
        "Palasa",
        "Pathapatnam",
        "Polaki",
        "Ponduru",
        "Rajam",
        "Ranastalam",
        "Regidi Amadalavalasa",
        "Santhabommali",
        "Santhakaviti",
        "Saravakota",
        "Sarubujjili",
        "Seethampeta",
        "Sompeta",
        "Srikakulam",
        "Tekkali",
        "Vajrapukothuru",
        "Vangara",
        "Veeraghattam"
    ],
    "Visakhapatnam": [
        "Anakapalle",
        "Anandapuram",
        "Ananthagiri",
        "Araku Valley",
        "Atchutapuram",
        "Bheemunipatnam",
        "Butchayyapeta",
        "Cheedikada",
        "Chintapalle",
        "Chodavaram",
        "Devarapalle",
        "Dumbriguda",
        "G.madugula",
        "Gajuwaka",
        "Golugonda",
        "Gudem Kotha Veedhi",
        "Hukumpeta",
        "K.kotapadu",
        "Kasimkota",
        "Kotauratla",
        "Koyyuru",
        "Madugula",
        "Makavarapalem",
        "Munagapaka",
        "Munchingi Puttu",
        "Nakkapalle",
        "Narsipatnam",
        "Nathavaram",
        "Paderu",
        "Padmanabham",
        "Paravada",
        "Payakaraopeta",
        "Peda Bayalu",
        "Pedagantyada",
        "Pendurthi",
        "Rambilli",
        "Ravikamatham",
        "Rolugunta",
        "S.rayavaram",
        "Sabbavaram",
        "Visakhapatnam (rural)",
        "Visakhapatnam (urban)",
        "Yelamanchili"
    ],
    "Vizianagaram": [
        "Badangi",
        "Balijipeta",
        "Bhogapuram",
        "Bobbili",
        "Bondapalle",
        "Cheepurupalle",
        "Dattirajeru",
        "Denkada",
        "Gajapathinagaram",
        "Gantyada",
        "Garividi",
        "Garugubilli",
        "Gummalakshmipuram",
        "Gurla",
        "Jami",
        "Jiyyammavalasa",
        "Komarada",
        "Kothavalasa",
        "Kurupam",
        "Lakkavarapukota",
        "Makkuva",
        "Mentada",
        "Merakamudidam",
        "Nellimarla",
        "Pachipenta",
        "Parvathipuram",
        "Pusapatirega",
        "Ramabhadrapuram",
        "Salur",
        "Seethanagaram",
        "Srungavarapukota",
        "Therlam",
        "Vepada",
        "Vizianagaram"
    ],
    "YSR Kadapa": [
        "Atlur",
        "B.kodur",
        "Badvel",
        "Brahmamgarimattam",
        "Chakrayapet",
        "Chapad",
        "Chennur",
        "Chinnamandem",
        "Chinthakommadinne",
        "Chitvel",
        "Duvvur",
        "Galiveedu",
        "Gopavaram",
        "Jammalamadugu",
        "Kadapa",
        "Kalasapadu",
        "Kamalapuram",
        "Khajipet",
        "Kodur",
        "Kondapuram",
        "Lakkireddipalle",
        "Lingala",
        "Muddanur",
        "Mylavaram",
        "Nandalur",
        "Obulavaripalle",
        "Peddamudium",
        "Penagalur",
        "Pendlimarri",
        "Porumamilla",
        "Proddatur",
        "Pulivendla",
        "Pullampeta",
        "Rajampet",
        "Rajupalem",
        "Ramapuram",
        "Rayachoti",
        "S.mydukur",
        "Sambepalle",
        "Sidhout",
        "Simhadripuram",
        "Sri Avadhutha Kasinayana",
        "T Sundupalle",
        "Thondur",
        "Vallur",
        "Veeraballe",
        "Veerapunayunipalle",
        "Vempalle",
        "Vemula",
        "Vontimitta",
        "Yerraguntla"
    ],
    "Tawang": [
        "Bongkhar",
        "Dudunghar Circle",
        "Jang Circle",
        "Kitpi Circle",
        "Lhou",
        "Lumla Circle",
        "Mukto Circle",
        "Tawang Circle",
        "Thingbu Circle",
        "Zemithang Circle"
    ],
    "Anjaw": [
        "Anjaw",
        "Chaglagam Circle",
        "Goiliang Circle",
        "Hawai Circle",
        "Hayuliang Circle",
        "Kibithoo Circle",
        "Manchal Circle",
        "Metengliang",
        "Walong Circle"
    ],
    "Namsai": [
        "Namsai"
    ],
    "Changlang": [
        "Bordumsa Circle",
        "Changlang Circle",
        "Diyun Circle",
        "Jairampur Circle",
        "Kharsang Circle",
        "Khimiyong Circle",
        "Lyngok-longtoi",
        "Manmao Circle",
        "Miao Circle",
        "Nampong Circle",
        "Namtok Circle",
        "Renuk",
        "Tikhak Rima Putok",
        "Vijoynagar Circle",
        "Yatdam"
    ],
    "Longding": [
        "Dadam",
        "Kanubari Circle",
        "Khonsa Circle",
        "Laju Circle",
        "Lawnu",
        "Longding Circle",
        "Namsang Circle",
        "Pangchao Circle",
        "Pumao Circle",
        "Soha",
        "Wakka Circle"
    ],
    "Baksa": [
        "Baganpara (pt)",
        "Bajali (pt)",
        "Baksa",
        "Barama (pt)",
        "Barnagar (pt)",
        "Baska",
        "Ghograpar (pt)",
        "Goreswar (pt)",
        "Jalah (pt)",
        "Mushalpur",
        "Pathorighat (pt)",
        "Rangia (pt)",
        "Sarupeta (pt)",
        "Tamulpur",
        "Tihu (pt)"
    ],
    "Barpeta": [
        "Baghbor",
        "Bajali (pt)",
        "Barnagar (pt)",
        "Barpeta",
        "Chenga",
        "Jalah (pt)",
        "Kalgachia",
        "Sarthebari",
        "Sarupeta (pt)"
    ],
    "Biswanath": [
        "Biswanath",
        "Chariduar",
        "Dhekiajuli (pt)",
        "Gohpur",
        "Helem",
        "Jamugurihat",
        "Na-duar",
        "Rangapara",
        "Sootea",
        "Tezpur"
    ],
    "Bongaigaon": [
        "Bijni (pt)",
        "Boitamari",
        "Bongaigaon (pt)",
        "Sidli (pt)",
        "Srijangram"
    ],
    "Chirang": [
        "Barnagar (pt)",
        "Basugaon",
        "Bengtol",
        "Bijni (pt)",
        "Bongaigaon (pt)",
        "Chirang",
        "Kokrajhar (pt)",
        "Sidli (pt)"
    ],
    "Dhemaji": [
        "Dhakuakhana (PT-II)",
        "Dhakuakhana (pt-i)",
        "Dhemaji",
        "Gogamukh",
        "Jonai",
        "Sissibargaon",
        "Subansiri (PT-II)",
        "Subansiri (pt-i)"
    ],
    "Dhubri": [
        "Bagribari (pt)",
        "Bhowraguri",
        "Bilasipara (pt)",
        "Chapar (pt)",
        "Dhubri (pt)",
        "Dotoma",
        "Golokganj (pt)",
        "Gossaigaon (pt)",
        "Kokrajhar (pt)",
        "Sidli (Pt.-I)"
    ],
    "Dibrugarh": [
        "Chabua",
        "Dibrugarh East",
        "Dibrugarh West",
        "Moran",
        "Naharkatiya",
        "Tengakhat",
        "Tingkhong"
    ],
    "Golaghat": [
        "Bokakhat",
        "Dergaon",
        "Golaghat",
        "Khumtai",
        "Morangi",
        "Sarupathar"
    ],
    "Hailakandi": [
        "Algapur",
        "Hailakandi",
        "Katlichara",
        "Lala"
    ],
    "Hojai": [
        "Dhing",
        "Doboka",
        "Hojai",
        "Kaliabor",
        "Kampur",
        "Lanka",
        "Nagaon",
        "Raha",
        "Rupahi",
        "Samaguri"
    ],
    "Jorhat": [
        "Dohtia",
        "Jorhat East",
        "Jorhat West",
        "Majuli",
        "Mariani",
        "Teok",
        "Titabor"
    ],
    "Karimganj": [
        "Badarpur",
        "Karimganj",
        "Nilambazar",
        "Patharkandi",
        "Ramkrishna Nagar"
    ],
    "Kokrajhar": [
        "Bagribari (pt)",
        "Bhowraguri",
        "Bilasipara (pt)",
        "Chapar (pt)",
        "Dhubri (pt)",
        "Dotoma",
        "Golokganj (pt)",
        "Gossaigaon (pt)",
        "Kokrajhar (pt)",
        "Sidli (Pt.-I)"
    ],
    "Lakhimpur": [
        "Bihpuria",
        "Dhakuakhana (pt-i)",
        "Kadam",
        "Naobaicha",
        "Narayanpur",
        "North Lakhimpur",
        "Subansiri (pt-i)"
    ],
    "Majuli": [
        "Dohtia",
        "Jorhat East",
        "Jorhat West",
        "Majuli",
        "Mariani",
        "Teok",
        "Titabor"
    ],
    "Nagaon": [
        "Dhing",
        "Doboka",
        "Hojai",
        "Kaliabor",
        "Kampur",
        "Lanka",
        "Nagaon",
        "Raha",
        "Rupahi",
        "Samaguri"
    ],
    "Nalbari": [
        "Baganpara (pt)",
        "Banekuchi",
        "Barama (pt)",
        "Barbhag",
        "Barkhetri",
        "Baska",
        "Belsor",
        "Ghograpar (pt)",
        "Mukalmua",
        "Nalbari",
        "Pachim Nalbari",
        "Tamulpur",
        "Tihu (pt)"
    ],
    "Dima Hasao": [
        "Dima Hasao",
        "Haflong",
        "Mahur",
        "Maibong",
        "Umrangso"
    ],
    "South Salmara-Mankachar": [
        "Agamoni",
        "Bagribari (pt)",
        "Bilasipara (pt)",
        "Chapar (pt)",
        "Dhubri (pt)",
        "Gauripur",
        "Golokganj (pt)",
        "Gossaigaon (pt)",
        "Mankachar",
        "South Salmara"
    ],
    "Tinsukia": [
        "Doom Dooma",
        "Margherita",
        "Sadiya",
        "Tinsukia"
    ],
    "Udalguri": [
        "Dalgaon (pt)",
        "Harisinga",
        "Kalaigaon (pt)",
        "Kharupetia",
        "Khoirabari (pt)",
        "Majbat",
        "Mangaldoi (pt)",
        "Pathorighat (pt)",
        "Sipajhar",
        "Udalguri"
    ],
    "Araria": [
        "Araria",
        "Bhargama",
        "Forbesganj",
        "Jokihat",
        "Kursakatta",
        "Narpatganj",
        "Palasi",
        "Raniganj",
        "Sikti"
    ],
    "Arwal": [
        "Arwal",
        "Ghoshi",
        "Hulasganj",
        "Jehanabad",
        "Kako",
        "Kaler",
        "Karpi",
        "Kurtha",
        "Makhdumpur",
        "Modanganj",
        "Ratni Faridpur",
        "Sonbhadra Banshi Suryapur"
    ],
    "Aurangabad": [
        "Aurangabad",
        "Gangapur",
        "Kannad",
        "Khuldabad",
        "Paithan",
        "Phulambri",
        "Sillod",
        "Soegaon",
        "Vaijapur",
        "Wahegaon"
    ],
    "Banka": [
        "Amarpur",
        "Banka",
        "Barahat",
        "Bausi",
        "Belhar",
        "Chanan",
        "Dhuraiya",
        "Katoria",
        "Phulidumar",
        "Rajaun",
        "Shambhuganj"
    ],
    "Begusarai": [
        "Bachhwara",
        "Bakhri",
        "Balia",
        "Barauni",
        "Begusarai",
        "Bhagwanpur",
        "Birpur",
        "Cheria Bariarpur",
        "Chhorahi",
        "Dandari",
        "Garhpura",
        "Khudabandpur",
        "Mansurchak",
        "Matihani",
        "Naokothi",
        "Sahebpur Kamal",
        "Shamho Akha Kurha",
        "Teghra"
    ],
    "Bhagalpur": [
        "Bhagalpur",
        "Bihpur",
        "Colgong",
        "Gopalpur",
        "Goradih",
        "Ismailpur",
        "Jagdishpur",
        "Kharik",
        "Narayanpur",
        "Nathnagar",
        "Naugachhia",
        "Pirpainti",
        "Rangra Chowk",
        "Sabour",
        "Shahkund",
        "Sonhaula",
        "Sultanganj"
    ],
    "Bhojpur": [
        "Agiaon",
        "Arrah",
        "Barhara",
        "Behea",
        "Bhojpur",
        "Charpokhari",
        "Dlippur",
        "Garhani",
        "Jagdishpur",
        "Koilwar",
        "Piro",
        "Sahar",
        "Sandesh",
        "Shahpur",
        "Tarari",
        "Udwant Nagar"
    ],
    "Buxar": [
        "Barhampur",
        "Buxar",
        "Chakki",
        "Chaugain",
        "Chausa",
        "Dumraon",
        "Itarhi",
        "Kesath",
        "Nawanagar",
        "Rajpur",
        "Rajpur Kalan (Parnahi)",
        "Simri"
    ],
    "Darbhanga": [
        "Alinagar",
        "Bahadurpur",
        "Baheri",
        "Benipur",
        "Biraul",
        "Darbhanga",
        "Devipur",
        "Dome",
        "Ghanshyampur",
        "Gora Bauram",
        "Hanumannagar",
        "Hayaghat",
        "Jale",
        "Keotiranway",
        "Kiratpur",
        "Kusheshwar Asthan",
        "Kusheshwar Asthan Purbi",
        "Manigachhi",
        "Singhwara",
        "Tardih"
    ],
    "East Champaran (Motihari)": [
        "Adapur",
        "Areraj",
        "Banjaria",
        "Bankatwa",
        "Chakia(pipra)",
        "Chiraia",
        "Dhaka",
        "Ghorasahan",
        "Harsidhi",
        "Kalyanpur",
        "Kesaria",
        "Kotwa",
        "Madhuban",
        "Mehsi",
        "Motihari",
        "Narkatia",
        "Paharpur",
        "Pakri Dayal",
        "Patahi",
        "Phenhara",
        "Piprakothi",
        "Ramgarhwa",
        "Raxaul",
        "Sangrampur",
        "Sugauli",
        "Tetaria",
        "Turkaulia"
    ],
    "Gaya": [
        "Amas",
        "Atri",
        "Banke Bazar",
        "Barachatti",
        "Belaganj",
        "Bodh Gaya",
        "Chandauti",
        "Dobhi",
        "Dumaria",
        "Fatehpur",
        "Gaya Town C.d.block",
        "Guraru",
        "Gurua",
        "Imamganj",
        "Khizirsarai",
        "Konch",
        "Manpur",
        "Mohanpur",
        "Muhra",
        "Neem Chak Bathani",
        "Paraiya",
        "Sherghati",
        "Tan Kuppa",
        "Tikari",
        "Wazirganj"
    ],
    "Gopalganj": [
        "Baikunthpur",
        "Barauli",
        "Bhorey",
        "Bijaipur",
        "Gopalganj",
        "Hathua",
        "Katiya",
        "Kuchaikote",
        "Manjha",
        "Mirganj",
        "Pach Deuri",
        "Phulwaria",
        "Sidhwalia",
        "Thawe",
        "Uchkagaon"
    ],
    "Jamui": [
        "Barhat",
        "Chakai",
        "Gidhaur",
        "Islamnagar Aliganj",
        "Jamui",
        "Jhajha",
        "Khaira",
        "Lakshmipur",
        "Sikandra",
        "Sono"
    ],
    "Jehanabad": [
        "Arwal",
        "Ghoshi",
        "Hulasganj",
        "Jehanabad",
        "Kako",
        "Kaler",
        "Karpi",
        "Kurtha",
        "Makhdumpur",
        "Modanganj",
        "Ratni Faridpur",
        "Sonbhadra Banshi Suryapur"
    ],
    "Kaimur (Bhabua)": [
        "Adhaura",
        "Bhabua",
        "Bhagwanpur",
        "Chainpur",
        "Chand",
        "Durgawati",
        "Kudra",
        "Mohania",
        "Nuaon",
        "Ramgarh",
        "Rampur"
    ],
    "Katihar": [
        "Amdabad",
        "Azamnagar",
        "Balrampur",
        "Barari",
        "Barsoi",
        "Dandkhora",
        "Falka",
        "Hasanganj",
        "Kadwa",
        "Katihar",
        "Korha",
        "Kursela",
        "Manihari",
        "Mansahi",
        "Pranpur",
        "Sameli"
    ],
    "Khagaria": [
        "Alauli",
        "Beldaur",
        "Chautham",
        "Dharhi",
        "Gogri",
        "Khagaria",
        "Mansi",
        "Parbatta"
    ],
    "Kishanganj": [
        "Bahadurganj",
        "Dighalbank",
        "Kishanganj",
        "Kochadhamin",
        "Pothia",
        "Terhagachh",
        "Thakurganj"
    ],
    "Lakhisarai": [
        "Barahiya",
        "Chanan*",
        "Halsi",
        "Lakhisarai",
        "Pipariya",
        "Ramgarh Chowk",
        "Surajgarha"
    ],
    "Madhepura": [
        "Alamnagar",
        "Bihariganj",
        "Chausa",
        "Gamharia",
        "Ghailarh",
        "Gwalpara",
        "Kishanganj",
        "Kumarkhand",
        "Madhepura",
        "Murliganj",
        "Puraini",
        "Shankarpur",
        "Singheshwar"
    ],
    "Madhubani": [
        "Bagaha",
        "Bairia",
        "Bettiah",
        "Bhitaha",
        "Chanpatia",
        "Gaunaha",
        "Jogapatti",
        "Lauriya",
        "Madhubani",
        "Mainatanr",
        "Majhaulia",
        "Narkatiaganj",
        "Nautan",
        "Piprasi",
        "Ramnagar",
        "Sidhaw",
        "Sikta",
        "Thakrahan"
    ],
    "Munger (Monghyr)": [
        "Asarganj",
        "Bariarpur",
        "Dharhara",
        "Jamalpur",
        "Kharagpur",
        "Munger",
        "Sangrampur",
        "Tarapur",
        "Tetiha Bambor"
    ],
    "Nawada": [
        "Akbarpur",
        "Gobindpur",
        "Hisua",
        "Kashi Chak",
        "Kawakol",
        "Meskaur",
        "Nardiganj",
        "Narhat",
        "Nawada",
        "Pakribarawan",
        "Rajauli",
        "Roh",
        "Sirdala",
        "Warisaliganj"
    ],
    "Patna": [
        "Athmalgola",
        "Bakhtiarpur",
        "Barh",
        "Belchhi",
        "Bihta",
        "Bikram",
        "Daniawan",
        "Dhanarua",
        "Dinapur-cum-khagaul",
        "Dulhin Bazar",
        "Fatwah",
        "Ghoswari",
        "Khusrupur",
        "Maner",
        "Masaurhi",
        "Mokameh",
        "Naubatpur",
        "Paliganj",
        "Pandarak",
        "Patna Rural",
        "Phulwari",
        "Punpun",
        "Sampatchak"
    ],
    "Rohtas": [
        "Akorhi Gola",
        "Bikramganj",
        "Chenari",
        "Dawath",
        "Dehri",
        "Dinara",
        "Karakat",
        "Kargahar",
        "Kochas",
        "Nasriganj",
        "Nauhatta",
        "Nokha",
        "Rajpur",
        "Rohtas",
        "Sanjhauli",
        "Sasaram",
        "Sheosagar",
        "Suryapura",
        "Tilouthu"
    ],
    "Saharsa": [
        "Agiaon",
        "Arrah",
        "Barhara",
        "Behea",
        "Bhojpur",
        "Charpokhari",
        "Dlippur",
        "Garhani",
        "Jagdishpur",
        "Koilwar",
        "Piro",
        "Sahar",
        "Sandesh",
        "Shahpur",
        "Tarari",
        "Udwant Nagar"
    ],
    "Samastipur": [
        "Bibhutpur",
        "Bithan",
        "Dalsinghsarai",
        "Hasanpur",
        "Kalyanpur",
        "Khanpur",
        "Mohanpur",
        "Mohiuddinagar",
        "Morwa",
        "Patori",
        "Pusa",
        "Rosera",
        "Samastipur",
        "Sarairanjan",
        "Shivaji Nagar",
        "Singhia",
        "Tajpur",
        "Ujiarpur",
        "Vidyapati Nagar",
        "Warisnagar"
    ],
    "Sheikhpura": [
        "Ariari",
        "Barbigha",
        "Chewara",
        "Ghat Kusumbha",
        "Sheikhpura",
        "Shekhopur Sarai"
    ],
    "Sheohar": [
        "Dumri Katsari",
        "Piprarhi",
        "Purnahiya",
        "Sheohar",
        "Tariani Chowk"
    ],
    "Siwan": [
        "Andar",
        "Barharia",
        "Basantpur",
        "Bhagwanpur Hat",
        "Darauli",
        "Daraundha",
        "Goriakothi",
        "Guthani",
        "Hasanpura",
        "Hussainganj",
        "Lakri Nabiganj",
        "Maharajganj",
        "Mairwa",
        "Nautan",
        "Pachrukhi",
        "Raghunathpur",
        "Siswan",
        "Siwan",
        "Ziradei"
    ],
    "Supaul": [
        "Basantpur",
        "Chhatapur",
        "Kishanpur",
        "Marauna",
        "Nirmali",
        "Pipra",
        "Pratapganj",
        "Raghopur",
        "Saraigarh Bhaptiyahi",
        "Supaul",
        "Tribeniganj"
    ],
    "Vaishali": [
        "Bhagwanpur",
        "Bidupur",
        "Chehra Kalan",
        "Desri",
        "Goraul",
        "Hajipur",
        "Jandaha",
        "Lalganj",
        "Mahnar",
        "Mahua",
        "Patepur",
        "Paterhi Belsar",
        "Raghopur",
        "Raja Pakar",
        "Sahdai Buzurg",
        "Vaishali"
    ],
    "Chandigarh": [
        "Chandigarh"
    ],
    "Balod": [
        "Balod",
        "Bemetara",
        "Berla",
        "Bhilai",
        "Dhamdha",
        "Dondi",
        "Dondi Luhara",
        "Durg",
        "Gunderdehi",
        "Gurur",
        "Nawagarh",
        "Patan",
        "Saja",
        "Sanjari balod",
        "Thanakhamria"
    ],
    "Baloda Bazar": [
        "Abhanpur",
        "Arang",
        "Baloda Bazar",
        "Bhatapara",
        "Bilaigarh",
        "Bindranavagarh(gariyaband)",
        "Chhura",
        "Deobhog",
        "Kasdol",
        "Mainpur",
        "Palari",
        "Raipur",
        "Rajim",
        "Simga",
        "Tilda"
    ],
    "Balrampur": [
        "Balrampur",
        "Harriya Satgharwa",
        "Tulsipur",
        "Utraula"
    ],
    "Bastar": [
        "Bade Rajpur",
        "Bakavand",
        "Bastanar",
        "Bastar",
        "Darbha",
        "Farasgaon",
        "Jagdalpur",
        "Keskal",
        "Kondagaon",
        "Lohandiguda",
        "Makdi",
        "Narayanpur",
        "Tokapal"
    ],
    "Bemetara": [
        "Balod",
        "Bemetara",
        "Berla",
        "Bhilai",
        "Dhamdha",
        "Dondi",
        "Dondi Luhara",
        "Durg",
        "Gunderdehi",
        "Gurur",
        "Nawagarh",
        "Patan",
        "Saja",
        "Sanjari balod",
        "Thanakhamria"
    ],
    "Bijapur": [
        "Bhopal pattanam",
        "Bijapur",
        "Chhindgarh",
        "Dantewada",
        "Gidam",
        "Katekalyan",
        "Konta",
        "Kuakonda",
        "Sukma"
    ],
    "Bilaspur": [
        "Bharari",
        "Bilaspur Sadar",
        "Ghumarwin",
        "Jhanduta",
        "Naina Devi",
        "Namhol"
    ],
    "Dantewada (South Bastar)": [
        "Bade Rajpur",
        "Bakavand",
        "Bastanar",
        "Bastar",
        "Darbha",
        "Farasgaon",
        "Jagdalpur",
        "Keskal",
        "Kondagaon",
        "Lohandiguda",
        "Makdi",
        "Narayanpur",
        "Tokapal"
    ],
    "Dhamtari": [
        "Dhamtari",
        "Kurud",
        "Magarlod",
        "Nagri"
    ],
    "Durg": [
        "Balod",
        "Bemetara",
        "Berla",
        "Bhilai",
        "Dhamdha",
        "Dondi",
        "Dondi Luhara",
        "Durg",
        "Gunderdehi",
        "Gurur",
        "Nawagarh",
        "Patan",
        "Saja",
        "Sanjari balod",
        "Thanakhamria"
    ],
    "Gariyaband": [
        "Abhanpur",
        "Arang",
        "Baloda Bazar",
        "Bhatapara",
        "Bilaigarh",
        "Bindranavagarh(gariyaband)",
        "Chhura",
        "Deobhog",
        "Kasdol",
        "Mainpur",
        "Palari",
        "Raipur",
        "Rajim",
        "Simga",
        "Tilda"
    ],
    "Janjgir-Champa": [
        "Akaltara",
        "Baloda",
        "Champa",
        "Dabhra",
        "Jaijaipur",
        "Janjgir",
        "Malkharoda",
        "Nawagarh",
        "Pamgarh",
        "Sakti"
    ],
    "Jashpur": [
        "Bagicha",
        "Duldula",
        "Farsabahar",
        "Jashpur",
        "Kansabel",
        "Kunkuri",
        "Manora",
        "Pathalgaon"
    ],
    "Kabirdham (Kawardha)": [
        "Bodla",
        "Kabirdham",
        "Kawardha",
        "Pandariya",
        "Sahaspur Lohara"
    ],
    "Kanker (North Bastar)": [
        "Antagarh",
        "Bhanupratappur",
        "Charama",
        "Durgkondal",
        "Kanker",
        "Narharpur",
        "Pakhanjur"
    ],
    "Kondagaon": [
        "Bade Rajpur",
        "Bakavand",
        "Bastanar",
        "Bastar",
        "Darbha",
        "Farasgaon",
        "Jagdalpur",
        "Keskal",
        "Kondagaon",
        "Lohandiguda",
        "Makdi",
        "Narayanpur",
        "Tokapal"
    ],
    "Korba": [
        "Kartala",
        "Katghora",
        "Korba",
        "Pali",
        "Poundi-uproda"
    ],
    "Mahasamund": [
        "Bagbahra",
        "Basna",
        "Mahasamund",
        "Pithora",
        "Saraipali"
    ],
    "Mungeli": [
        "Bilaspur",
        "Bilha",
        "Kota",
        "Lormi",
        "Marwahi",
        "Masturi",
        "Mungeli",
        "Pathariya",
        "Pendra",
        "Pendra Road Gorella",
        "Takhatpur"
    ],
    "Narayanpur": [
        "Bade Rajpur",
        "Bakavand",
        "Bastanar",
        "Bastar",
        "Darbha",
        "Farasgaon",
        "Jagdalpur",
        "Keskal",
        "Kondagaon",
        "Lohandiguda",
        "Makdi",
        "Narayanpur",
        "Tokapal"
    ],
    "Raigarh": [
        "Baramkela",
        "Chhuriya",
        "Gharghoda",
        "Kharsia",
        "Lailunga",
        "Pusour",
        "Raigarh",
        "Sarangarh",
        "Sopul",
        "Tamnar",
        "Udaipur (dharamjaigarh)"
    ],
    "Raipur": [
        "Abhanpur",
        "Arang",
        "Baloda Bazar",
        "Bhatapara",
        "Bilaigarh",
        "Bindranavagarh(gariyaband)",
        "Chhura",
        "Deobhog",
        "Kasdol",
        "Mainpur",
        "Palari",
        "Raipur",
        "Rajim",
        "Simga",
        "Tilda"
    ],
    "Rajnandgaon": [
        "Ambagarh",
        "Chhuikhadan",
        "Chhuriya",
        "Dongargaon",
        "Dongargarh",
        "Khairagarh",
        "Manpur",
        "Mohla",
        "Rajnandgaon"
    ],
    "Sukma": [
        "Bhopal pattanam",
        "Bijapur",
        "Chhindgarh",
        "Dantewada",
        "Gidam",
        "Katekalyan",
        "Konta",
        "Kuakonda",
        "Sukma"
    ],
    "Surajpur  ": [
        "Ambikapur",
        "Balrampur",
        "Batouli",
        "Bhaiyathan",
        "Lakhanpur",
        "Lundra",
        "Mainpat",
        "Oudgi",
        "Pal",
        "Pratappur",
        "Premnagar",
        "Rajpur",
        "Ramanujganj",
        "Ramanujnagar",
        "Samri(kusmi)",
        "Shankargarh",
        "Sitapur",
        "Surajpur",
        "Surguja",
        "Udaypur",
        "Wadrafnagar"
    ],
    "Surguja": [
        "Ambikapur",
        "Balrampur",
        "Batouli",
        "Bhaiyathan",
        "Lakhanpur",
        "Lundra",
        "Mainpat",
        "Oudgi",
        "Pal",
        "Pratappur",
        "Premnagar",
        "Rajpur",
        "Ramanujganj",
        "Ramanujnagar",
        "Samri(kusmi)",
        "Shankargarh",
        "Sitapur",
        "Surajpur",
        "Surguja",
        "Udaypur",
        "Wadrafnagar"
    ],
    "Daman": [
        "Daman"
    ],
    "Diu": [
        "Diu"
    ],
    "Shahdara": [
        "Alipur",
        "Seelam Pur",
        "Seema Puri",
        "Shahdara"
    ],
    "Ahmedabad": [
        "Ahmedabad City",
        "Barwala",
        "Bavla",
        "Daskroi",
        "Detroj-rampura",
        "Dhandhuka",
        "Dholka",
        "Mandal",
        "Ranpur",
        "Sanand",
        "Viramgam"
    ],
    "Amreli": [
        "Amreli",
        "Babra",
        "Bagasara",
        "Dhari",
        "Jafrabad",
        "Khambha",
        "Kunkavav Vadia",
        "Lathi",
        "Lilia",
        "Rajula",
        "Savar Kundla"
    ],
    "Anand": [
        "Anand",
        "Anklav",
        "Borsad",
        "Khambhat",
        "Petlad",
        "Sojitra",
        "Tarapur",
        "Umreth"
    ],
    "Banaskantha (Palanpur)": [
        "Aarkhi",
        "Amirgadh",
        "Banas Kantha",
        "Bayad",
        "Bhabhar",
        "Danta",
        "Dantiwada",
        "Deesa",
        "Deodar",
        "Dhanera",
        "Kangrej",
        "Kankrej",
        "Lakhani",
        "Palanpur",
        "Suigam",
        "Tharad",
        "Tolad",
        "Vadgam",
        "Vav",
        "ider"
    ],
    "Bharuch": [
        "Amod",
        "Anklesvar",
        "Bharuch",
        "Hansot",
        "Jambusar",
        "Jhagadia",
        "Kantharia",
        "Netrang",
        "Vagra",
        "Valia"
    ],
    "Bhavnagar": [
        "Bhavnagar",
        "Botad",
        "Gadhada",
        "Gariadhar",
        "Ghogha",
        "Jesar",
        "Mahuva",
        "Palitana",
        "Sihor",
        "Talaja",
        "Umrala",
        "Vallabhipur"
    ],
    "Botad": [
        "Bhavnagar",
        "Botad",
        "Gadhada",
        "Gariadhar",
        "Ghogha",
        "Jesar",
        "Mahuva",
        "Palitana",
        "Sihor",
        "Talaja",
        "Umrala",
        "Vallabhipur"
    ],
    "Chhota Udepur": [
        "Bodeli",
        "Chhota Udepur",
        "Nasvadi",
        "Sankheda"
    ],
    "Dangs (Ahwa)": [
        "Ahwa",
        "The Dangs"
    ],
    "Devbhoomi Dwarka": [
        "Bhanvad",
        "Bhatiya",
        "Dwarka",
        "Kalyanpur",
        "Khambhaliya"
    ],
    "Gandhinagar": [
        "Chilota",
        "Dehgam",
        "Gandhinagar",
        "Kalol",
        "Mansa"
    ],
    "Gir Somnath": [
        "Gir-Gadhada",
        "Kodinar",
        "Somnath",
        "Sutrapada",
        "Talala",
        "Una",
        "Veraval"
    ],
    "Jamnagar": [
        "Bhanvad",
        "Dhrol",
        "Jamjodhpur",
        "Jamnagar",
        "Jodiya",
        "Kalavad",
        "Kalyanpur",
        "Khambhalia",
        "Lalpur",
        "Okhamandal"
    ],
    "Junagadh": [
        "Bhesan",
        "Junagadh",
        "Keshod",
        "Kodinar",
        "Malia",
        "Manavadar",
        "Mangrol",
        "Mendarda",
        "Patan-veraval",
        "Sutrapada",
        "Talala",
        "Una",
        "Vanthali",
        "Visavadar"
    ],
    "Kheda (Nadiad)": [
        "Balasinor",
        "Dakor",
        "Galtesvar",
        "Kapadvanj",
        "Kathlal",
        "Kheda",
        "Mahudha",
        "Matar",
        "Mehmedabad",
        "Nadiad",
        "Thasra",
        "Virpur"
    ],
    "Mahisagar": [
        "Balasinor",
        "Kadana",
        "Khanpur",
        "Lunavada",
        "Mahisagar",
        "Santrampur",
        "Virpur"
    ],
    "Morbi": [
        "Halvad",
        "Maliya Miyana",
        "Morbi",
        "Paurgao",
        "Sankara"
    ],
    "Narmada (Rajpipla)": [
        "Dediapada",
        "Nandod",
        "Rajpipla",
        "Sagbara",
        "Tilakwada"
    ],
    "Navsari": [
        "Bansda",
        "Chikhli",
        "Gandevi",
        "Jalalpore",
        "Navsari"
    ],
    "Panchmahal (Godhra)": [
        "Ghoghamba",
        "Godhra",
        "Halol",
        "Jambughoda",
        "Kadana",
        "Kalol",
        "Khanpur",
        "Lunawada",
        "Morwa (hadaf)",
        "Santrampur",
        "Shehera"
    ],
    "Patan": [
        "Chanasma",
        "Harij",
        "Patan",
        "Radhanpur",
        "Sami",
        "Sankeshwar",
        "Santalpur",
        "Sarswasti",
        "Sidhpur",
        "Vagdod"
    ],
    "Porbandar": [
        "Kutiyana",
        "Porbandar",
        "Ranavav"
    ],
    "Rajkot": [
        "Baloda",
        "Dhoraji",
        "Gondal",
        "Jamkandorna",
        "Jasdan",
        "Jetpur",
        "Kotda Sangani",
        "Lodhika",
        "Maliya",
        "Morvi",
        "Paddhari",
        "Rajkot",
        "Tankara",
        "Upleta",
        "Virpur",
        "Wankaner"
    ],
    "Surat": [
        "Bardoli",
        "Chorasi",
        "Kamrej",
        "Kosam",
        "Mahuva",
        "Mandvi",
        "Mangrol",
        "Nizar",
        "Olpad",
        "Palsana",
        "Songadh",
        "Surat City",
        "Uchchhal",
        "Umarpada",
        "Valod",
        "Variav",
        "Vyara"
    ],
    "Tapi (Vyara)": [
        "Bardoli",
        "Chorasi",
        "Kamrej",
        "Kosam",
        "Mahuva",
        "Mandvi",
        "Mangrol",
        "Nizar",
        "Olpad",
        "Palsana",
        "Songadh",
        "Surat City",
        "Uchchhal",
        "Umarpada",
        "Valod",
        "Variav",
        "Vyara"
    ],
    "Vadodara": [
        "Chhota Udaipur",
        "Dabhoi",
        "Desra",
        "Jetpur Pavi",
        "Karjan",
        "Kavant",
        "Nasvadi",
        "Padra",
        "Por",
        "Sankheda",
        "Savli",
        "Sinor",
        "Vadodara",
        "Vaghodia"
    ],
    "Valsad": [
        "Dharampur",
        "Kaprada",
        "Pardi",
        "Umbergaon",
        "Valsad",
        "vapi"
    ],
    "Ambala": [
        "Ambala",
        "Barara",
        "Naraingarh",
        "Saha"
    ],
    "Bhiwani": [
        "Badhra",
        "Bawani Khera",
        "Bhiwani",
        "Dadri",
        "Dinod",
        "Loharu",
        "Siwani",
        "Tosham"
    ],
    "Charkhi Dadri": [
        "Badhra",
        "Birhi Kalan",
        "Charkhi Dadri"
    ],
    "Faridabad": [
        "Badkal",
        "Ballabgarh",
        "Faridabad",
        "Hathin",
        "Hodal",
        "Palwal"
    ],
    "Fatehabad": [
        "Agroha",
        "Bhattu Mandi",
        "Bhuna",
        "Fatehabad",
        "Jakhal",
        "Ratia",
        "Tohana"
    ],
    "Gurgaon": [
        "Farrukhnagar",
        "Ferozepur Jhirka",
        "Gurgaon",
        "Haileymandi",
        "Kadipur",
        "Manesar",
        "Nuh",
        "Pataudi",
        "Punahana",
        "Sohna",
        "Taoru"
    ],
    "Hisar": [
        "Adampur",
        "Agroha",
        "Barwala",
        "Hansi",
        "Hisar",
        "Narnaund",
        "Siwani",
        "Uklanamandi"
    ],
    "Jhajjar": [
        "Badli",
        "Bahadurgarh",
        "Beri",
        "Jhajjar",
        "Matenhail",
        "Silana"
    ],
    "Jind": [
        "Jind",
        "Julana",
        "Narwana",
        "Safidon",
        "Uchana"
    ],
    "Kaithal": [
        "Cheeka",
        "Fatehpur Pundri",
        "Guhla",
        "Kaithal",
        "Kalayat",
        "Pundri",
        "Rajond",
        "Siwan",
        "Tand"
    ],
    "Karnal": [
        "Assandh",
        "Gharaunda",
        "Indri",
        "Karnal",
        "Nilokheri",
        "Nissing"
    ],
    "Mahendragarh": [
        "Ateli",
        "Kanina",
        "Mahendragarh",
        "Naganl chaudhary",
        "Narnaul"
    ],
    "Mewat": [
        "Ferozepur Jhirka",
        "Mewat",
        "Nuh",
        "Punahana",
        "Taoru"
    ],
    "Palwal": [
        "Badkal",
        "Ballabgarh",
        "Faridabad",
        "Hathin",
        "Hodal",
        "Palwal"
    ],
    "Panchkula": [
        "Barwala",
        "Kalka",
        "Panchkula",
        "Raipur Rani"
    ],
    "Panipat": [
        "Bapauli",
        "Gohana",
        "Israna",
        "Kumarkha",
        "Madlauda",
        "Panipat",
        "Samalkha"
    ],
    "Rewari": [
        "Bawal",
        "Dharuhera",
        "Khol",
        "Kosli",
        "Nahar",
        "Rewari"
    ],
    "Rohtak": [
        "Kalanaur",
        "Maham",
        "Rohtak",
        "Sampla"
    ],
    "Sirsa": [
        "CHOPTA",
        "Dabwali",
        "Ellenabad",
        "Kalanwali",
        "Khairpur",
        "Odhan",
        "Rania",
        "Sirsa"
    ],
    "Sonipat": [
        "Ganaur",
        "Gohana",
        "Khairpur",
        "Kharkhoda",
        "Sonipat",
        "rai"
    ],
    "Yamunanagar": [
        "Bilaspur",
        "Chhachhrauli",
        "Jagadhri",
        "Rabur",
        "Saraswati Nagar",
        "Yamunanagar"
    ],
    "Chamba": [
        "Bhalai",
        "Bhattiyat",
        "Brahmaur",
        "Chamba",
        "Chaurah",
        "Dalhousie",
        "Holi",
        "Pangi",
        "Saluni",
        "Sihunta"
    ],
    "Hamirpur": [
        "Hamirpur",
        "Maudaha",
        "Rath",
        "Sarila",
        "Sumerpur"
    ],
    "Kangra": [
        "Baijnath",
        "Baroh",
        "Dera Gopipur",
        "Dharmsala",
        "Dhira",
        "Fatehpur",
        "Harchakian",
        "Indora",
        "Jaisinghpur",
        "Jaswan",
        "Jawalamukhi",
        "Jawali",
        "Kangra",
        "Khundian",
        "Multhan",
        "Nagrota Bagwan",
        "Nurpur",
        "Palampur",
        "Rakkar",
        "Shahpur",
        "Thural"
    ],
    "Kullu": [
        "Ani",
        "Banjar",
        "Bhuntar",
        "Kullu",
        "Manali",
        "Nermand",
        "Sainj"
    ],
    "Lahaul &amp; Spiti": [
        "Lahul",
        "Spiti",
        "Udaipur"
    ],
    "Mandi": [
        "Aut",
        "Baldwara",
        "Bali Chowki",
        "Bhadrota",
        "Chachyot",
        "Dharmpur",
        "Jogindarnagar",
        "Karsog",
        "Kotli",
        "Lad Bharol",
        "Mandi",
        "Nihri",
        "Padhar",
        "Sandhol",
        "Sarkaghat",
        "Sundarnagar",
        "Thunag"
    ],
    "Shimla": [
        "Basantpur",
        "Chaupal",
        "Cheta",
        "Chirgaon",
        "Dodra Kwar",
        "Jubbal",
        "Junga",
        "Kotkhai",
        "Kumharsain",
        "Nankhari",
        "Nerua",
        "Rampur",
        "Rohru",
        "Seoni",
        "Shimla   ( Rural )",
        "Shimla (urban)",
        "Theog",
        "Tikar"
    ],
    "Solan": [
        "Arki",
        "Baddi",
        "Darlaghat",
        "Kandaghat",
        "Kasauli",
        "Krishangarh",
        "Nalagarh",
        "Ramshahr",
        "Solan"
    ],
    "Una": [
        "Amb",
        "Bangana",
        "Basdehra",
        "Bharwain",
        "Haroli",
        "Una"
    ],
    "Anantnag": [
        "Anantnag",
        "Bijbehara",
        "Dooru",
        "Kokernag",
        "Kulgam",
        "Pahalgam",
        "Shangus"
    ],
    "Bandipore": [
        "Bandipore",
        "Baramulla",
        "Boniyar",
        "Gulmarg",
        "Gurez",
        "Kreeri",
        "Pattan",
        "Rafiabad",
        "Sonawari",
        "Sopore",
        "Tangmarg",
        "Uri"
    ],
    "Baramulla": [
        "Bandipore",
        "Baramulla",
        "Boniyar",
        "Gulmarg",
        "Gurez",
        "Kreeri",
        "Pattan",
        "Rafiabad",
        "Sonawari",
        "Sopore",
        "Tangmarg",
        "Uri"
    ],
    "Budgam": [
        "Badgam",
        "Beerwah",
        "Budgam",
        "Chadoora",
        "Charar- E- Shrief",
        "Khag",
        "Khansahib",
        "Narbal"
    ],
    "Doda": [
        "Banihal",
        "Bhaderwah",
        "Bhalessa (Gandoh)",
        "Doda",
        "Gandoh",
        "Kishtwar",
        "Ramban",
        "Thathri"
    ],
    "Ganderbal": [
        "Ganderbal",
        "Kangan",
        "Srinagar",
        "Srinagar (north)",
        "Srinagar (south)"
    ],
    "Jammu": [
        "Akhnoor",
        "Bishnah",
        "Jammu",
        "Marh",
        "Ranbir Singh Pora",
        "Samba"
    ],
    "Kargil": [
        "Kargil",
        "Sanku",
        "Zanskar"
    ],
    "Kathua": [
        "Bani",
        "Bashohli",
        "Billawar",
        "Hiranagar",
        "Kathua"
    ],
    "Kishtwar": [
        "Banihal",
        "Bhaderwah",
        "Bhalessa (Gandoh)",
        "Doda",
        "Gandoh",
        "Kishtwar",
        "Ramban",
        "Thathri"
    ],
    "Kulgam": [
        "Anantnag",
        "Bijbehara",
        "Dooru",
        "Kokernag",
        "Kulgam",
        "Pahalgam",
        "Shangus"
    ],
    "Kupwara": [
        "Handwara",
        "Karnah",
        "Kupwara"
    ],
    "Leh": [
        "Khalsi",
        "Leh",
        "Nubra"
    ],
    "Pulwama": [
        "Awantipora",
        "Pampore",
        "Pulwama",
        "Shupiyan",
        "Tral"
    ],
    "Rajouri": [
        "Bandipore",
        "Baramulla",
        "Boniyar",
        "Gulmarg",
        "Gurez",
        "Kreeri",
        "Pattan",
        "Rafiabad",
        "Sonawari",
        "Sopore",
        "Tangmarg",
        "Uri"
    ],
    "Ramban": [
        "Banihal",
        "Bhaderwah",
        "Bhalessa (Gandoh)",
        "Doda",
        "Gandoh",
        "Kishtwar",
        "Ramban",
        "Thathri"
    ],
    "Reasi": [
        "Chenani",
        "Gool Gulab Garh",
        "Majalta",
        "Ramnagar",
        "Reasi",
        "Udhampur"
    ],
    "Samba": [
        "Akhnoor",
        "Bishnah",
        "Jammu",
        "Marh",
        "Ranbir Singh Pora",
        "Samba"
    ],
    "Shopian": [
        "Shopian"
    ],
    "Srinagar": [
        "Ganderbal",
        "Kangan",
        "Srinagar",
        "Srinagar (north)",
        "Srinagar (south)"
    ],
    "Udhampur": [
        "Chenani",
        "Gool Gulab Garh",
        "Majalta",
        "Ramnagar",
        "Reasi",
        "Udhampur"
    ],
    "Bokaro": [
        "Bermo",
        "Bokaro",
        "Chandankiyari",
        "Chandrapura",
        "Chas",
        "Gumia",
        "Jaridih",
        "Kasmar",
        "Nawadih",
        "Peterwar"
    ],
    "Chatra": [
        "Chatra",
        "Gidhaur",
        "Hunterganj",
        "Itkhori",
        "Kanha Chatti",
        "Kunda",
        "Lawalaung",
        "Mayur Hand",
        "Pathalgora",
        "Pratappur",
        "Shaligram Ram Narayanpur(hunterganj)",
        "Simaria",
        "Tandwa"
    ],
    "Deoghar": [
        "Deoghar",
        "Devipur",
        "Karon",
        "Madhupur",
        "Margo Munda",
        "Mohanpur",
        "Palojori",
        "Sarath",
        "Sarwan",
        "Sona Rai Tharhi"
    ],
    "Dhanbad": [
        "Baghmara-cum-katras",
        "Baliapur",
        "Dhanbad-cum-kenduadih-cum-jagata",
        "Gobindpur",
        "Jharia-cum-jorapokhar-cum-sindri",
        "Nirsa-cum-chirkunda",
        "Purbi Tundi",
        "Topchanchi",
        "Tundi"
    ],
    "Dumka": [
        "Dumka",
        "Gopikandar",
        "Jama",
        "Jarmundi",
        "Kathikund",
        "Masalia",
        "Ramgarh",
        "Ranishwar",
        "Saraiyahat",
        "Shikaripara"
    ],
    "East Singhbhum": [
        "East Singhbhum",
        "Harhar guttu",
        "Jamshedpur"
    ],
    "Garhwa": [
        "Bardiha",
        "Bhandaria",
        "Bhawnathpur",
        "Bishunpura",
        "Chinia",
        "Danda",
        "Dandai",
        "Dhurki",
        "Garhwa",
        "Kandi",
        "Ketar",
        "Kharaundhi",
        "Majhiaon",
        "Meral (pipra Kalan)",
        "Nagaruntari",
        "Ramkanda",
        "Ramna",
        "Ranka",
        "Sagma"
    ],
    "Giridih": [
        "Bagodar",
        "Bengabad",
        "Birni",
        "Deori",
        "Dhanwar",
        "Dumri",
        "Gande",
        "Gawan",
        "Giridih",
        "Jamua",
        "Pirtanr",
        "Sariya",
        "Tisri"
    ],
    "Godda": [
        "Basantrai",
        "Bashant Rai",
        "Boarijor",
        "Godda",
        "Mahagama",
        "Meherma",
        "Pathargama",
        "Poreyahat",
        "Sundarpahari",
        "Thakurgangti"
    ],
    "Gumla": [
        "Albert Ekka(jari)",
        "Bano",
        "Basia",
        "Bishunpur",
        "Bolba",
        "Chainpur",
        "Dumri",
        "Ghaghra",
        "Gumla",
        "Jaldega",
        "Kamdara",
        "Kolebira",
        "Kurdeg",
        "Palkot",
        "Raidih",
        "Sisai",
        "Toto",
        "Verno",
        "simdega"
    ],
    "Hazaribag": [
        "Barhi",
        "Barkagaon",
        "Barkatha",
        "Bishungarh",
        "Chalkusa",
        "Chauparan",
        "Churchu",
        "Dadi",
        "Daru",
        "Gola",
        "Hazaribag",
        "Ichak",
        "Katamdag",
        "Katkamsandi",
        "Keredari",
        "Korrah",
        "Mandu",
        "Padma",
        "Patratu",
        "Ramgarh",
        "Tati Jhariya"
    ],
    "Jamtara": [
        "Fatehpur",
        "Jamtara",
        "Karma Tanr Vidyasagar",
        "Kundhit",
        "Nala",
        "Narayanpur"
    ],
    "Khunti": [
        "Angara",
        "Bero",
        "Bundu",
        "Burmu",
        "Chanho",
        "Erki (Tamar II)",
        "Itki",
        "Kanke",
        "Karra",
        "Khelari",
        "Khunti",
        "Lapung",
        "Mandar",
        "Murhu",
        "Nagri",
        "Namkum",
        "Ormanjhi",
        "Rahe",
        "Ranchi",
        "Rania",
        "Ratu",
        "Silli",
        "Sonahatu",
        "Tamar I",
        "Torpa"
    ],
    "Latehar": [
        "Balumath",
        "Barwadih",
        "Bishrampur",
        "Chainpur",
        "Chandwa",
        "Chhatarpur",
        "Daltonganj",
        "Garu",
        "Haidernagar",
        "Hariharganj",
        "Hussainabad",
        "Latehar",
        "Leslieganj",
        "Mahuadanr",
        "Manatu",
        "Manika",
        "Medininagar(daltonganj)",
        "Mohammad Ganj",
        "Nagar Utari",
        "Nawa Bazar",
        "Nawadiha Bazar/nawadiha",
        "Nilambar-pitambarpur(lesliganj)",
        "Padwa",
        "Pandu",
        "Panki",
        "Patan",
        "Pipra",
        "Satbarwa",
        "Tarhasi",
        "Untari Road"
    ],
    "Lohardaga": [
        "Bhandra",
        "Kairo",
        "Kisko",
        "Kuru",
        "Lohardaga",
        "Peshrar",
        "Senha"
    ],
    "Pakur": [
        "Amrapara",
        "Hiranpur",
        "Litipara",
        "Maheshpur",
        "Pakaur",
        "Pakuria"
    ],
    "Ramgarh": [
        "Barhi",
        "Barkagaon",
        "Barkatha",
        "Bishungarh",
        "Chalkusa",
        "Chauparan",
        "Churchu",
        "Dadi",
        "Daru",
        "Gola",
        "Hazaribag",
        "Ichak",
        "Katamdag",
        "Katkamsandi",
        "Keredari",
        "Korrah",
        "Mandu",
        "Padma",
        "Patratu",
        "Ramgarh",
        "Tati Jhariya"
    ],
    "Ranchi": [
        "Angara",
        "Bero",
        "Bundu",
        "Burmu",
        "Chanho",
        "Erki (Tamar II)",
        "Itki",
        "Kanke",
        "Karra",
        "Khelari",
        "Khunti",
        "Lapung",
        "Mandar",
        "Murhu",
        "Nagri",
        "Namkum",
        "Ormanjhi",
        "Rahe",
        "Ranchi",
        "Rania",
        "Ratu",
        "Silli",
        "Sonahatu",
        "Tamar I",
        "Torpa"
    ],
    "Sahibganj": [
        "Barhait",
        "Barharwa",
        "Borio",
        "Mandro",
        "Pathna",
        "Rajmahal",
        "Sahibganj",
        "Taljhari",
        "Udhwa"
    ],
    "Seraikela-Kharsawan": [
        "Adityapur (Gamharia)",
        "Anandpur",
        "Bandgaon",
        "Chaibasa",
        "Chakradharpur",
        "Chandil",
        "Gobindpur (Rajnagar)",
        "Goilkera",
        "Gudri",
        "Hat Gamharia",
        "Hatgamaria",
        "Ichagarh",
        "Jagannathpur",
        "Jhinkpani",
        "Kharsawan",
        "Khuntpani",
        "Kuchai",
        "Kumardungi",
        "Majhgaon",
        "Manjhari",
        "Manoharpur",
        "Nimdih",
        "Noamundi",
        "Seraikela",
        "Sonua",
        "Tantnagar",
        "Tonto"
    ],
    "Simdega": [
        "Albert Ekka(jari)",
        "Bano",
        "Basia",
        "Bishunpur",
        "Bolba",
        "Chainpur",
        "Dumri",
        "Ghaghra",
        "Gumla",
        "Jaldega",
        "Kamdara",
        "Kolebira",
        "Kurdeg",
        "Palkot",
        "Raidih",
        "Sisai",
        "Toto",
        "Verno",
        "simdega"
    ],
    "West Singhbhum": [
        "Manoharpur",
        "west singhbhum"
    ],
    "Bagalkot": [
        "Badami",
        "Bagalkot",
        "Bilgi",
        "Halagali",
        "Hungund",
        "Ilkal",
        "Jamkhandi",
        "Mudhol",
        "Terdal"
    ],
    "Ballari (Bellary)": [
        "Arpan Hally",
        "Bellary",
        "Hadagalli",
        "Hagaribommanahalli",
        "Hospet",
        "Huvinahadagali",
        "Kampli",
        "Kudligi",
        "Kurugodu",
        "Sandur",
        "Siruguppa"
    ],
    "Belagavi (Belgaum)": [
        "Athni",
        "Bailhongal",
        "Belgaum",
        "Chikodi",
        "Gokak",
        "Hukeri",
        "Khanapur",
        "Kittur",
        "Kudachi",
        "Nippani",
        "Parasgad",
        "Ramdurg",
        "Raybag",
        "Salahalli",
        "Sampgaon",
        "Saundatti-Yellamm",
        "Sedam",
        "kagwad"
    ],
    "Bengaluru (Bangalore) Rural": [
        "Alur",
        "Arkalgud",
        "Arsikere",
        "Belur",
        "Channarayapatna",
        "Hassan",
        "Hole Narsipur",
        "Sakleshpur"
    ],
    "Bengaluru (Bangalore) Urban": [
        "Alur",
        "Arkalgud",
        "Arsikere",
        "Belur",
        "Channarayapatna",
        "Hassan",
        "Hole Narsipur",
        "Sakleshpur"
    ],
    "Bidar": [
        "Aurad",
        "Basavakalyan",
        "Bhalki",
        "Bidar",
        "Homnabad"
    ],
    "Chamarajanagar": [
        "Chamarajanagar",
        "Gundlupet",
        "Kollegal",
        "Yelandur"
    ],
    "Chikballapur": [
        "Bagepalli",
        "Bangarapet",
        "Chik Ballapur",
        "Chintamani",
        "Gauribidanur",
        "Gudibanda",
        "Kolar",
        "Malur",
        "Mulbagal",
        "Sidlaghatta",
        "Srinivaspur"
    ],
    "Chikkamagaluru (Chikmagalur)": [
        "Chikmagalur",
        "Kadur",
        "Koppa",
        "Mudigere",
        "Narasimharajapura",
        "Panchanahalli",
        "Sringeri",
        "Tarikere"
    ],
    "Chitradurga": [
        "Challakere",
        "Chitradurga",
        "Hiriyur",
        "Holalkere",
        "Hosdurga",
        "Molakalmuru"
    ],
    "Dharwad": [
        "Dharwad",
        "Hubli",
        "Kalghatgi",
        "Kundgol",
        "Navalgund",
        "Yarebudihall"
    ],
    "Gadag": [
        "Gadag",
        "Lakshmeshwar",
        "Mundargi",
        "Nargund",
        "Ron",
        "Shirhatti"
    ],
    "Hassan": [
        "Alur",
        "Arkalgud",
        "Arsikere",
        "Belur",
        "Channarayapatna",
        "Hassan",
        "Hole Narsipur",
        "Sakleshpur"
    ],
    "Haveri": [
        "Byadgi",
        "Halagi",
        "Hangal",
        "Haveri",
        "Hirekerur",
        "Ranibennur",
        "Rattihalli",
        "Savanur",
        "Shiggaon"
    ],
    "Kalaburagi (Gulbarga)": [
        "Afzalpur",
        "Aland",
        "Chincholi",
        "Chitapur",
        "Gulbarga",
        "Jevargi",
        "Sedam",
        "Shahpur",
        "Shorapur",
        "Yadgir"
    ],
    "Kolar": [
        "Bagepalli",
        "Bangarapet",
        "Chik Ballapur",
        "Chintamani",
        "Gauribidanur",
        "Gudibanda",
        "Kolar",
        "Malur",
        "Mulbagal",
        "Sidlaghatta",
        "Srinivaspur"
    ],
    "Koppal": [
        "Gangawati",
        "Kanakagir",
        "Koppal",
        "Kushtagi",
        "Yelbarga"
    ],
    "Mandya": [
        "Krishnarajpet",
        "Maddur",
        "Malavalli",
        "Mandya",
        "Nagamangala",
        "Pandavapura",
        "Shrirangapattana"
    ],
    "Mysuru (Mysore)": [
        "Heggadadevankote",
        "Hunsur",
        "Krishnarajanagara",
        "Mysore",
        "Nanjangud",
        "Piriyapatna",
        "Tirumakudal - Narsipur"
    ],
    "Raichur": [
        "Devadurga",
        "Lingsugur",
        "Manvi",
        "Maski",
        "Raichur",
        "Sindhnur"
    ],
    "Ramanagara": [
        "Channapatana",
        "Channapatna",
        "Kanakapura",
        "Magadi",
        "Ramanagara"
    ],
    "Shivamogga (Shimoga)": [
        "Bhadravati",
        "Hosanagara",
        "Sagar",
        "Shikarpur",
        "Shimoga",
        "Sorab",
        "Tirthahalli"
    ],
    "Tumakuru (Tumkur)": [
        "Chiknayakanhalli",
        "Gubbi",
        "Koratagere",
        "Kunigal",
        "Madhugiri",
        "Pavagada",
        "Sira",
        "Tiptur",
        "Tumkur",
        "Turuvekere"
    ],
    "Udupi": [
        "Karkal",
        "Kundapura",
        "Udupi"
    ],
    "Uttara Kannada (Karwar)": [
        "Ankola",
        "Bhatkal",
        "Haliyal",
        "Honavar",
        "Karwar",
        "Kumta",
        "Mundgod",
        "Siddapur",
        "Sirsi",
        "Supa",
        "Uttara Kannada",
        "Yellapur"
    ],
    "Vijayapura (Bijapur)": [
        "Basavana Bagevadi",
        "Bijapur",
        "Indi",
        "Muddebihal",
        "Sindgi"
    ],
    "Yadgir": [
        "Afzalpur",
        "Aland",
        "Chincholi",
        "Chitapur",
        "Gulbarga",
        "Jevargi",
        "Sedam",
        "Shahpur",
        "Shorapur",
        "Yadgir"
    ],
    "Alappuzha": [
        "Ambalappuzha",
        "Chengannur",
        "Cherthala",
        "Karthikappally",
        "Kattanam",
        "Kuttanad",
        "Mavelikkara"
    ],
    "Kannur": [
        "Kannur",
        "Taliparamba",
        "Thalassery"
    ],
    "Kasaragod": [
        "Hosdurg",
        "Kasaragod"
    ],
    "Kollam": [
        "Karunagappally",
        "Kollam",
        "Kottarakkara",
        "Kunnathur",
        "Pathanapuram"
    ],
    "Kottayam": [
        "Changanassery",
        "Kanjirappally",
        "Kottayam",
        "Meenachil",
        "Vaikom"
    ],
    "Kozhikode": [
        "Kozhikode",
        "Quilandy",
        "Vadakara"
    ],
    "Palakkad": [
        "Alathur",
        "Chittur",
        "Mannarkad",
        "Ottappalam",
        "Palakkad"
    ],
    "Thiruvananthapuram": [
        "Chirayinkeezhu",
        "Nedumangad",
        "Neyyattinkara",
        "Thiruvananthapuram"
    ],
    "Thrissur": [
        "Chavakkad",
        "Kodungallur",
        "Mukundapuram",
        "Talappilly",
        "Thrissur"
    ],
    "Agatti": [
        "Agatti",
        "Amini",
        "Andrott",
        "Bitra",
        "Chetlat",
        "Kadmat",
        "Kalpeni",
        "Kavaratti",
        "Kiltan",
        "Minicoy"
    ],
    "Amini": [
        "Agatti",
        "Amini",
        "Andrott",
        "Bitra",
        "Chetlat",
        "Kadmat",
        "Kalpeni",
        "Kavaratti",
        "Kiltan",
        "Minicoy"
    ],
    "Kavaratti": [
        "Agatti",
        "Amini",
        "Andrott",
        "Bitra",
        "Chetlat",
        "Kadmat",
        "Kalpeni",
        "Kavaratti",
        "Kiltan",
        "Minicoy"
    ],
    "Kadmath": [
        "Agatti",
        "Amini",
        "Andrott",
        "Bitra",
        "Chetlat",
        "Kadmat",
        "Kalpeni",
        "Kavaratti",
        "Kiltan",
        "Minicoy"
    ],
    "Kalpeni": [
        "Agatti",
        "Amini",
        "Andrott",
        "Bitra",
        "Chetlat",
        "Kadmat",
        "Kalpeni",
        "Kavaratti",
        "Kiltan",
        "Minicoy"
    ],
    "Minicoy": [
        "Agatti",
        "Amini",
        "Andrott",
        "Bitra",
        "Chetlat",
        "Kadmat",
        "Kalpeni",
        "Kavaratti",
        "Kiltan",
        "Minicoy"
    ],
    "Agar Malwa": [
        "Agar",
        "Akodia",
        "Badod",
        "Gulana",
        "Kalapipal",
        "Moman Badodiya",
        "Nalkheda",
        "Polay Kalan",
        "Shajapur",
        "Shujalpur",
        "Susner"
    ],
    "Alirajpur": [
        "Alirajpur",
        "Bhavra",
        "Jhabua",
        "Jobat",
        "Kalidevi Rama",
        "Meghnagar",
        "Petlawad",
        "Ranapur",
        "Thandla"
    ],
    "Anuppur": [
        "Anuppur",
        "Beohari",
        "Jaisinghnagar",
        "Jaithari",
        "Jaitpur",
        "Shahdol",
        "Sohagpur"
    ],
    "Ashoknagar": [
        "Aron",
        "Ashoknagar",
        "Bamori",
        "Chachaura",
        "Chanderi",
        "Guna",
        "Isagarh",
        "Kumbhraj",
        "Maksoodangarh",
        "Mungaoli",
        "Raghogarh"
    ],
    "Balaghat": [
        "Baihar",
        "Balaghat",
        "Katangi",
        "Khairlanji",
        "Kirnapur",
        "Lalbarra",
        "Lanji",
        "Paraswada",
        "Tirodi",
        "Waraseoni"
    ],
    "Barwani": [
        "Anjad",
        "Barwani",
        "Niwali",
        "Pansemal",
        "Pati",
        "Rajpur",
        "Sendhwa",
        "Thikri",
        "Varla"
    ],
    "Betul": [
        "Amla",
        "Athner",
        "Betul",
        "Bhainsdehi",
        "Chicholi",
        "Ghoda Dongri",
        "Multai",
        "Shahpur"
    ],
    "Bhind": [
        "Ater",
        "Bhind",
        "Gohad",
        "Gormi",
        "Lahar",
        "Mehgaon",
        "Mihona",
        "Ron"
    ],
    "Bhopal": [
        "Berasia",
        "Bhopal",
        "Gulabganj",
        "Huzur",
        "Nazirabad",
        "Saket Nagar"
    ],
    "Burhanpur": [
        "Burhanpur",
        "Khaknar",
        "Nepanagar",
        "Shahpur"
    ],
    "Chhatarpur": [
        "Bada Malhera",
        "Bijawar",
        "Buxwaha",
        "Chandla",
        "Chhatarpur",
        "Gaurihar",
        "Ghuwara",
        "Laundi",
        "Lav Kush Nagar",
        "Maharajpur",
        "Nowgong",
        "Rajnagar"
    ],
    "Chhindwara": [
        "Amarwara",
        "Bichhua",
        "Chand",
        "Chaurai",
        "Chhindwara",
        "Harrai",
        "Jamai",
        "Junnardeo",
        "Mohkhed",
        "Pandhurna",
        "Parasia",
        "Sausar",
        "Tamia",
        "Umreth"
    ],
    "Damoh": [
        "Batiyagarh",
        "Damoh",
        "Hatta",
        "Jabera",
        "Patera",
        "Patharia",
        "Tendukheda"
    ],
    "Datia": [
        "Badori",
        "Barwani kudai",
        "Bhander",
        "Datia",
        "Indergarh",
        "Senguwan",
        "Seondha"
    ],
    "Dewas": [
        "Bagli",
        "Chapda",
        "Dewas",
        "Gopalnagar",
        "Hatpiplya",
        "Kannod",
        "Khategaon",
        "Satwas",
        "Sonkatch",
        "Tonk Khurd",
        "Udaynagar"
    ],
    "Dhar": [
        "Badnawar",
        "Dahi",
        "Dhamnod",
        "Dhar",
        "Dharampuri",
        "Gandhwani",
        "Kukshi",
        "Manawar",
        "Sardarpur",
        "khalghat"
    ],
    "Dindori": [
        "Bagag",
        "Dindori",
        "Samnapur",
        "Shahpura"
    ],
    "Guna": [
        "Aron",
        "Ashoknagar",
        "Bamori",
        "Chachaura",
        "Chanderi",
        "Guna",
        "Isagarh",
        "Kumbhraj",
        "Maksoodangarh",
        "Mungaoli",
        "Raghogarh"
    ],
    "Gwalior": [
        "Bhitarwar",
        "Chinour",
        "Dabra (pichhore)",
        "Ghatigaon",
        "Gird",
        "Gwalior (gird)",
        "Murar",
        "Pichhore"
    ],
    "Harda": [
        "Handiya",
        "Harda",
        "Khirkiya",
        "Rehatgaon",
        "Sirali",
        "Timarni"
    ],
    "Hoshangabad": [
        "Babai",
        "Banapura",
        "Bankhedi",
        "Dolariya",
        "Hoshangabad",
        "Itarsi",
        "Pipariya",
        "Seoni-malwa",
        "Sohagpur"
    ],
    "Indore": [
        "Depalpur",
        "Hatod",
        "Indore",
        "Manpur",
        "Mhow",
        "Sawer"
    ],
    "Jabalpur": [
        "Chhitapal",
        "Jabalpur",
        "Kundam",
        "Majholi",
        "Panagar",
        "Patan",
        "Sehpura",
        "Shahpura",
        "Sihora"
    ],
    "Jhabua": [
        "Alirajpur",
        "Bhavra",
        "Jhabua",
        "Jobat",
        "Kalidevi Rama",
        "Meghnagar",
        "Petlawad",
        "Ranapur",
        "Thandla"
    ],
    "Katni": [
        "Badwara",
        "Bahoriband",
        "Barhi",
        "Dhimarkheda",
        "Katni",
        "Murwara",
        "Rithi",
        "Vijayraghavgarh"
    ],
    "Khandwa": [
        "Harsud",
        "Khalwa",
        "Khandwa",
        "Pandhana",
        "Punasa"
    ],
    "Khargone": [
        "Barwaha",
        "Bhagwanpura",
        "Bhikangaon",
        "Gogaon",
        "Jhiranya",
        "Kasrawad",
        "Khargone",
        "Maheshwar",
        "Sanawad",
        "Segaon",
        "Zirnia"
    ],
    "Mandla": [
        "Bichhiya",
        "Ghughari",
        "Ghughri",
        "Mandla",
        "Nainpur",
        "Narayanganj",
        "Niwas"
    ],
    "Mandsaur": [
        "Babulda",
        "Bhanpura",
        "Daloda",
        "Garoth",
        "Malhargarh",
        "Mandsaur",
        "Shamgarh",
        "Sitamau",
        "Sohagpur",
        "Sonkatch",
        "Susner",
        "Suwasara"
    ],
    "Morena": [
        "Ambah",
        "Banmore",
        "Joura",
        "Kailaras",
        "Morena",
        "Porsa",
        "Sabalgarh"
    ],
    "Narsinghpur": [
        "Gadarwara",
        "Gotegaon",
        "Kareli",
        "Narsinghpur",
        "Tendukheda"
    ],
    "Neemuch": [
        "Jawad",
        "Jiran",
        "Manasa",
        "Neemuch",
        "Rampura",
        "Singoli"
    ],
    "Panna": [
        "Ajaigarh",
        "Amanganj",
        "Devendranagar",
        "Gunnor",
        "Panna",
        "Pawai",
        "Raipura",
        "Shahnagar"
    ],
    "Raisen": [
        "Badi",
        "Baraily",
        "Begamganj",
        "Gairatganj",
        "Goharganj",
        "Raisen",
        "Salamatpur",
        "Silwani",
        "Sultanpur",
        "Udaipura"
    ],
    "Rajgarh": [
        "Biaora",
        "Jirapur",
        "Khilchipur",
        "Khujner",
        "Machalpur",
        "Narsinghgarh",
        "Pachore",
        "Rajgarh",
        "Sarangpur"
    ],
    "Ratlam": [
        "Alot",
        "Bajna",
        "Jaora",
        "Piploda",
        "Ratlam",
        "Rawti",
        "Sailana",
        "Tal"
    ],
    "Rewa": [
        "Chakghat",
        "Chitrangi",
        "Chunari",
        "Churhat",
        "Deosar",
        "Gopad",
        "Gurh",
        "Hanumana",
        "Huzur",
        "Jawa",
        "Kushmi",
        "Majholi",
        "Mangawan",
        "Mauganj",
        "Naigarhi",
        "Raipur - Karchuliyan",
        "Rampur Naikin",
        "Rewa",
        "Semaria",
        "Sihawal",
        "Simriya",
        "Singrauli",
        "Sirmour",
        "Teonthar"
    ],
    "Sagar": [
        "Banda",
        "Bina",
        "Deori",
        "Garhakota",
        "Jaisinagar",
        "Kesli",
        "Khurai",
        "Malthon",
        "Rahatgarh",
        "Rehli",
        "Sagar",
        "Shahgarh"
    ],
    "Satna": [
        "Amarpatan",
        "Birsinghpur",
        "Kotar",
        "Maihar",
        "Majhgawan",
        "Nagod",
        "Raghurajnagar",
        "Ramnagar",
        "Rampur Baghelan",
        "Satna",
        "Sohawal",
        "Unchahara"
    ],
    "Sehore": [
        "Ashta",
        "Baroda",
        "Bijapur",
        "Budni",
        "Ichhawar",
        "Jawar",
        "Nasrullaganj",
        "Rehti",
        "Sehore",
        "Shyampur"
    ],
    "Seoni": [
        "Barghat",
        "Chhapara",
        "Dhanora",
        "Ghansaur",
        "Keolari",
        "Kurai",
        "Lakhnadon",
        "Seoni"
    ],
    "Shahdol": [
        "Anuppur",
        "Beohari",
        "Jaisinghnagar",
        "Jaithari",
        "Jaitpur",
        "Shahdol",
        "Sohagpur"
    ],
    "Shajapur": [
        "Agar",
        "Akodia",
        "Badod",
        "Gulana",
        "Kalapipal",
        "Moman Badodiya",
        "Nalkheda",
        "Polay Kalan",
        "Shajapur",
        "Shujalpur",
        "Susner"
    ],
    "Sheopur": [
        "Badoda",
        "Beerpur",
        "Bijapur",
        "Karahal",
        "Sheopur",
        "Vijaypur"
    ],
    "Shivpuri": [
        "Badarwas",
        "Karera",
        "Khaniyadhana",
        "Kolaras",
        "Lakhnadon",
        "Narwar",
        "Pichhore",
        "Pohri",
        "Shivpuri"
    ],
    "Singrauli": [
        "Chakghat",
        "Chitrangi",
        "Chunari",
        "Churhat",
        "Deosar",
        "Gopad",
        "Gurh",
        "Hanumana",
        "Huzur",
        "Jawa",
        "Kushmi",
        "Majholi",
        "Mangawan",
        "Mauganj",
        "Naigarhi",
        "Raipur - Karchuliyan",
        "Rampur Naikin",
        "Rewa",
        "Semaria",
        "Sihawal",
        "Simriya",
        "Singrauli",
        "Sirmour",
        "Teonthar"
    ],
    "Tikamgarh": [
        "Badagaone",
        "Baldeogarh",
        "Jatara",
        "Khargapur",
        "Lidhora",
        "Mohangarh",
        "Niwari",
        "Orchha",
        "Palera",
        "Prithvipur",
        "Tikamgarh"
    ],
    "Ujjain": [
        "Badnagar",
        "Ghatiya",
        "Khacharod",
        "Mahidpur",
        "Nagda",
        "Tarana",
        "Ujjain"
    ],
    "Umaria": [
        "Bandhogarh",
        "Chandia",
        "Manpur",
        "Nowrozabad",
        "Pali",
        "Umaria"
    ],
    "Vidisha": [
        "Basoda",
        "Bhateri",
        "Ganj Basoda",
        "Gulabganj",
        "Gyaraspur",
        "Kurwai",
        "Lateri",
        "Nateran",
        "Shamshabad",
        "Sironj",
        "Tyonda",
        "Vidisha"
    ],
    "Ahmednagar": [
        "Ahmadpur",
        "Akola",
        "Jamkhed",
        "Karjat",
        "Kopargaon",
        "Nagar",
        "Nevasa",
        "Parner",
        "Pathardi",
        "Rahta",
        "Rahuri",
        "Sangamner",
        "Shevgaon",
        "Shirdi",
        "Shrigonda",
        "Shrirampur",
        "Tisgaon"
    ],
    "Akola": [
        "Akola",
        "Akot",
        "Balapur",
        "Barshitakli",
        "Murtijapur",
        "Patur",
        "Telhara"
    ],
    "Amravati": [
        "Achalpur",
        "Amravati",
        "Anjangaon Surji",
        "Bhatkuli",
        "Chandur Railway",
        "Chandurbazar",
        "Chikhaldara",
        "Daryapur",
        "Dhamangaon Railway",
        "Dharni",
        "Mahuli",
        "Morshi",
        "Nandgaon-khandeshwar",
        "Paratwada",
        "Pawaba",
        "Teosa",
        "Warud"
    ],
    "Beed": [
        "Ambajogai",
        "Ashti",
        "Beed",
        "Dharur",
        "Gevrai",
        "Kaij",
        "Majalgaon",
        "Parali (Vaijnath)",
        "Patoda",
        "Shirur (Kasar)",
        "Wadwani"
    ],
    "Bhandara": [
        "Bhandara",
        "Lakhandur",
        "Lakhani",
        "Mohadi",
        "Pauni",
        "Sakoli",
        "Tumsar"
    ],
    "Chandrapur": [
        "Ballarpur",
        "Bhadravati",
        "Brahmapuri",
        "Chandrapur",
        "Chimur",
        "Gondpipri",
        "Jiwati",
        "Korpana",
        "Mul",
        "Nagbhir",
        "Pombhurna",
        "Rajura",
        "Sawali",
        "Sindewahi",
        "Warora"
    ],
    "Dhule": [
        "Akkalkuwa",
        "Akrani",
        "Dhule",
        "Nandurbar",
        "Nawapur",
        "Shahade",
        "Talode"
    ],
    "Gadchiroli": [
        "Aheri",
        "Armori",
        "Bhamragad",
        "Chamorshi",
        "Desaiganj (vadasa)",
        "Dhanora",
        "Etapalli",
        "Gadchiroli",
        "Korchi",
        "Kurkheda",
        "Mulchera",
        "Sironcha"
    ],
    "Hingoli": [
        "Aundha (nagnath)",
        "Basmat",
        "Basmath",
        "Hingoli",
        "Kalamnuri",
        "Sengaon"
    ],
    "Jalgaon": [
        "Amalner",
        "Bhadgaon",
        "Bhusawal",
        "Bodvad",
        "Chalisgaon",
        "Chopda",
        "Dharangaon",
        "Edlabad (Muktainagar)",
        "Erandol",
        "Jalgaon",
        "Jamner",
        "Muktainagar (edlabad)",
        "Pachora",
        "Parola",
        "Raver",
        "Yawal"
    ],
    "Jalna": [
        "Ambad",
        "Badnapur",
        "Bhokardan",
        "Ghansawangi",
        "Jafferabad",
        "Jalna",
        "Madnapur",
        "Mantha",
        "Partur"
    ],
    "Latur": [
        "Ahmadpur",
        "Ausa",
        "Chakur",
        "Deoni",
        "Jalkot",
        "Latur",
        "Nilanga",
        "Renapur",
        "Shirur-anantpal",
        "Udgir"
    ],
    "Mumbai City": [
        "Mumbai"
    ],
    "Mumbai Suburban": [
        "Mumbai Suburban"
    ],
    "Nagpur": [
        "Ahmedpur",
        "Bhiwapur",
        "Hingna",
        "Kalameshwar",
        "Kamptee",
        "Katol",
        "Kuhi",
        "Mauda",
        "Nagpur (rural)",
        "Nagpur (urban)",
        "Narkhed",
        "Parseoni",
        "Ramtek",
        "Savner",
        "Umred"
    ],
    "Nanded": [
        "Ardhapur",
        "Bhokar",
        "Biloli",
        "Deglur",
        "Dharmabad",
        "Hadgaon",
        "Himayatnagar",
        "Kandhar",
        "Kinwat",
        "Loha",
        "Mahoor",
        "Mudkhed",
        "Mukhed",
        "Naigaon (khairgaon)",
        "Nanded",
        "Umri"
    ],
    "Nandurbar": [
        "Akkalkuwa",
        "Akrani",
        "Dhule",
        "Nandurbar",
        "Nawapur",
        "Shahade",
        "Talode"
    ],
    "Nashik": [
        "Baglan",
        "Chandvad",
        "Deola",
        "Dindori",
        "Igatpuri",
        "Jindori",
        "Kalwan",
        "Khatana",
        "Laslgaon",
        "Malavalli",
        "Malegaon",
        "Manmad",
        "Nandgaon",
        "Nashik",
        "Niphad",
        "Peint",
        "Pimpalgaon Baswant",
        "Satana",
        "Sinnar",
        "Surgana",
        "Trimbakeshwar",
        "Uttam Nagar",
        "Yevla"
    ],
    "Osmanabad": [
        "Bhum",
        "Kalamb",
        "Lohara",
        "Osmanabad",
        "Paranda",
        "Tuljapur",
        "Umarga",
        "Washi"
    ],
    "Palghar": [
        "Ambarnath",
        "Bhiwandi",
        "Dahanu",
        "Jawhar",
        "Kalyan",
        "Mokhada",
        "Murbad",
        "Palghar",
        "Shahapur",
        "Talasari",
        "Thane",
        "Ulhasnagar",
        "Vada",
        "Vasai",
        "Vikramgad"
    ],
    "Parbhani": [
        "Gangakhed",
        "Jintur",
        "Manwath",
        "Palam",
        "Parbhani",
        "Pathri",
        "Purna",
        "Sailu",
        "Sonpeth"
    ],
    "Pune": [
        "Ambegaon",
        "Baramati",
        "Bhor",
        "Daund",
        "Haveli",
        "Indapur",
        "Junnar",
        "Khed",
        "Mawal",
        "Mulshi",
        "Narayangaon",
        "Pune City",
        "Purandhar",
        "Rajguru Nagar",
        "Saswad",
        "Shirur",
        "Velhe"
    ],
    "Ratnagiri": [
        "Chiplun",
        "Dapoli",
        "Guhagar",
        "Khed",
        "Lanja",
        "Mandangad",
        "Rajapur",
        "Ratnagiri",
        "Sangameshwar"
    ],
    "Satara": [
        "Jaoli",
        "Karad",
        "Khandala",
        "Khatav",
        "Koregaon",
        "Mahabaleshwar",
        "Man",
        "Patan",
        "Phaltan",
        "Satara",
        "Shirval",
        "Vaduj",
        "Wai"
    ],
    "Solapur": [
        "Akkalkot",
        "Akluj",
        "Barshi",
        "Boramani",
        "Karmala",
        "Madha",
        "Malshiras",
        "Mangalvedhe",
        "Mohol",
        "Pandharpur",
        "Sangole",
        "Solapur North",
        "Solapur South"
    ],
    "Thane": [
        "Ambarnath",
        "Bhiwandi",
        "Dahanu",
        "Jawhar",
        "Kalyan",
        "Mokhada",
        "Murbad",
        "Palghar",
        "Shahapur",
        "Talasari",
        "Thane",
        "Ulhasnagar",
        "Vada",
        "Vasai",
        "Vikramgad"
    ],
    "Wardha": [
        "Arvi",
        "Ashti",
        "Deoli",
        "Hinganghat",
        "Karanja",
        "Pulgaon",
        "Samudrapur",
        "Seloo",
        "Wardha"
    ],
    "Washim": [
        "Karanja",
        "Malegaon",
        "Mangrulpir",
        "Manora",
        "Risod",
        "Washim"
    ],
    "Yavatmal": [
        "Arni",
        "Babulgaon",
        "Darwha",
        "Digras",
        "Ghatanji",
        "Kalamb",
        "Kelapur",
        "Mahagaon",
        "Maregaon",
        "Ner",
        "Pusad",
        "Ralegaon",
        "Umarkhed",
        "Wani",
        "Yavatmal",
        "Zari-jamani"
    ],
    "Bishnupur": [
        "Bishnupur",
        "Moirang",
        "Nambol"
    ],
    "Chandel": [
        "Chakpikarong",
        "Chandel",
        "Machi",
        "Tengnoupal"
    ],
    "Churachandpur": [
        "Churachandpur",
        "Churachandpur North",
        "Singngat",
        "Thanlon",
        "Tipaimukh"
    ],
    "Jiribam": [
        "Jiribam",
        "Keirao Bitra",
        "Porompat",
        "Sawombung"
    ],
    "Kakching": [
        "Kakching",
        "Lilong",
        "Thoubal"
    ],
    "Kamjong": [
        "Kamjong-chassad",
        "Phungyar-phaisat",
        "Ukhrul North",
        "Ukhrul South",
        "Ukhurl Central"
    ],
    "Tamenglong": [
        "Nungba",
        "Tamenglong",
        "Tamenglong North",
        "Tamenglong West"
    ],
    "Tengnoupal": [
        "Chakpikarong",
        "Chandel",
        "Machi",
        "Tengnoupal"
    ],
    "Thoubal": [
        "Kakching",
        "Lilong",
        "Thoubal"
    ],
    "Ukhrul": [
        "Kamjong-chassad",
        "Phungyar-phaisat",
        "Ukhrul North",
        "Ukhrul South",
        "Ukhurl Central"
    ],
    "Champhai": [
        "Champhai",
        "East Lungdar (part)",
        "Khawbung",
        "Khawzawl",
        "Ngopa"
    ],
    "Lawngtlai": [
        "Chawngte",
        "Lawngtlai",
        "S\" Bungtlang",
        "Sangau"
    ],
    "Lunglei": [
        "Hnahthial",
        "Lunglei",
        "Lungsen",
        "West Bunghmun"
    ],
    "Saiha": [
        "Saiha",
        "Sangau",
        "Tuipang"
    ],
    "Serchhip": [
        "East Lungdar (part)",
        "Serchhip",
        "Thingsulthliah (part)"
    ],
    "Dimapur": [
        "Aquqhnaqua",
        "Chumukedima",
        "Dhansiripar",
        "Dimapur Sadar",
        "Kuhoboto",
        "Medziphema",
        "Nihokhu",
        "Niuland"
    ],
    "Kiphire": [
        "Amahator",
        "Chare",
        "Chessore",
        "Chingmei",
        "Kiphire Sadar",
        "Kiusam",
        "Longkhim",
        "Longleng",
        "Longmatra",
        "Mangko",
        "Ngoungchung",
        "Nokhu",
        "Noklak",
        "Noksen",
        "Panso",
        "Pungro",
        "Sangsangnyu",
        "Seyochung",
        "Shamator",
        "Sitimi",
        "Sotokur",
        "Tamlu",
        "Thonoknyu",
        "Tsurungto",
        "Tuensang Sadar",
        "Yongya"
    ],
    "Kohima": [
        "Athibung",
        "Botsa",
        "Chiephobozou",
        "Jakhama",
        "Jalukie",
        "Kezocha",
        "Kohima Sadar",
        "Nsong",
        "Pedi (Ngwalwa)",
        "Peren",
        "Sechu",
        "Sechu-zubza",
        "Tening",
        "Tseminyu",
        "Tsogin"
    ],
    "Longleng": [
        "Amahator",
        "Chare",
        "Chessore",
        "Chingmei",
        "Kiphire Sadar",
        "Kiusam",
        "Longkhim",
        "Longleng",
        "Longmatra",
        "Mangko",
        "Ngoungchung",
        "Nokhu",
        "Noklak",
        "Noksen",
        "Panso",
        "Pungro",
        "Sangsangnyu",
        "Seyochung",
        "Shamator",
        "Sitimi",
        "Sotokur",
        "Tamlu",
        "Thonoknyu",
        "Tsurungto",
        "Tuensang Sadar",
        "Yongya"
    ],
    "Mon": [
        "Aboi",
        "Angjangyang",
        "Chen",
        "Hunta",
        "Longching",
        "Longshen",
        "Mon Sadar",
        "Monyakshu",
        "Mopong",
        "Naginimora",
        "Phomching",
        "Shangnyu",
        "Tizit",
        "Tobu",
        "Wakching"
    ],
    "Peren": [
        "Athibung",
        "Botsa",
        "Chiephobozou",
        "Jakhama",
        "Jalukie",
        "Kezocha",
        "Kohima Sadar",
        "Nsong",
        "Pedi (Ngwalwa)",
        "Peren",
        "Sechu",
        "Sechu-zubza",
        "Tening",
        "Tseminyu",
        "Tsogin"
    ],
    "Phek": [
        "Chetheba",
        "Chizami",
        "Chozuba",
        "Khezhakeno",
        "Khuza",
        "Meluri",
        "Pfutsero",
        "Phek Sadar",
        "Phokhungri",
        "Phor",
        "Razieba",
        "Sakraba",
        "Sekruzu",
        "Zuketsa"
    ],
    "Tuensang": [
        "Amahator",
        "Chare",
        "Chessore",
        "Chingmei",
        "Kiphire Sadar",
        "Kiusam",
        "Longkhim",
        "Longleng",
        "Longmatra",
        "Mangko",
        "Ngoungchung",
        "Nokhu",
        "Noklak",
        "Noksen",
        "Panso",
        "Pungro",
        "Sangsangnyu",
        "Seyochung",
        "Shamator",
        "Sitimi",
        "Sotokur",
        "Tamlu",
        "Thonoknyu",
        "Tsurungto",
        "Tuensang Sadar",
        "Yongya"
    ],
    "Wokha": [
        "Aitepyong",
        "Baghty",
        "Bhandari",
        "Changpang",
        "Chukitong",
        "Englan",
        "Lotsu",
        "Ralan",
        "Sanis",
        "Sungro",
        "Wokha Sadar",
        "Wozhuro"
    ],
    "Zunheboto": [
        "Aghunato",
        "Akuhaito",
        "Akuluto",
        "Asuto",
        "Atoizu",
        "Ghathashi",
        "Pughoboto",
        "Saptiqa",
        "Satakha",
        "Satoi",
        "Suruhuto",
        "V.k.",
        "Zunheboto Sadar"
    ],
    "Balangir": [
        "Balangir",
        "Bandhapada",
        "Bangomunda",
        "Belpara",
        "Kantabanji",
        "Khaprakhol",
        "Loisinga",
        "Muribahal",
        "Patnagarh",
        "Saintala",
        "Sindhekela",
        "Titlagarh",
        "Turekela",
        "Tushura"
    ],
    "Balasore": [
        "Balasore",
        "Basta",
        "Bhanaga",
        "Jaleswar",
        "Remuna",
        "Simulia"
    ],
    "Bargarh": [
        "Ambabhona",
        "Attabira",
        "Barapali",
        "Bargarh",
        "Bargarh Sadar",
        "Bhatli",
        "Bheden",
        "Bijepur",
        "Burden",
        "Gaisilet",
        "Jharbandha",
        "Melchhamunda",
        "Padmapur",
        "Paikamal",
        "Sohela"
    ],
    "Bhadrak": [
        "Agarpada",
        "Bansada",
        "Bant",
        "Basudebpur",
        "Bhadrak Rural",
        "Bhandari Pokhari",
        "Chandabali",
        "Dhamanagar",
        "Dhamara Marine",
        "Dhusuri",
        "Naikanidihi",
        "Tihidi"
    ],
    "Cuttack": [
        "Athagad",
        "Badamba",
        "Baidyeswar",
        "Banki",
        "Barang",
        "C.r.r.i.",
        "Choudwar",
        "Cuttack (m.corp.) P.s",
        "Cuttack Sadar",
        "Gobindpur",
        "Gurudijhatia",
        "Jagatpur",
        "Kandarpur",
        "Kanpur",
        "Khuntuni",
        "Kishannagar",
        "Mahanga",
        "Narasinghpur",
        "Nemalo",
        "Niali",
        "Nischintakoili",
        "Olatapur",
        "Salepur",
        "Tangi",
        "Tigiria"
    ],
    "Dhenkanal": [
        "Balimi",
        "Bhuban",
        "Bhusan Steel Limited",
        "Dhenkanal Sadar",
        "Gandia",
        "Hindol",
        "Kamakshyanagar",
        "Kankadahad",
        "Motunga",
        "Nihalprasad",
        "Parajang",
        "Rasol",
        "Tumusingha"
    ],
    "Ganjam": [
        "Arjyapalli Marine",
        "Asika",
        "Badagada",
        "Bhanjanagar",
        "Brahmapur (m.corp.)",
        "Brahmapur Sadar",
        "Buguda",
        "Chamakhandi",
        "Chhatrapur",
        "Chikiti",
        "Dharakote",
        "Digapahandi",
        "Gangapur",
        "Ganjam",
        "Golanthara",
        "Gopalpur",
        "Hinjili",
        "Jagannath Prasad",
        "Jarada",
        "Kabisuryanagar",
        "Khalikote",
        "Kodala",
        "Nuagaon",
        "Patapur",
        "Polasara",
        "Purusottampur",
        "Ramagiri",
        "Rambha",
        "Seragad",
        "Surada",
        "Tarasingi"
    ],
    "Jagatsinghapur": [
        "Abhyachandpur",
        "Balikuda",
        "Biridi",
        "Ersama",
        "Jagatsinghapur",
        "Kujang",
        "Naugaon",
        "Paradeep Lock",
        "Paradip",
        "Tirtol"
    ],
    "Jajpur": [
        "Badachana",
        "Balichandrapur",
        "Bari - Ramachandrapur",
        "Binjharpur",
        "Chandikhol",
        "Dangadi",
        "Dharmasala",
        "Duburi",
        "Jajapur",
        "Jajapur Road",
        "Jajpur Sadar",
        "Jakhapura",
        "Jenapur",
        "Kaliapani",
        "Kalinganagar",
        "Korai",
        "Kuakhia",
        "Mangalpur",
        "Panikoili",
        "Sukinda",
        "Tomka"
    ],
    "Jharsuguda": [
        "Badmal",
        "Banaharapali",
        "Belpahar",
        "Brajarajnagar",
        "Jharsuguda",
        "Kolabira",
        "Laikera",
        "Lakhanpur",
        "Orient",
        "Rengali"
    ],
    "Kandhamal": [
        "Ainthapali",
        "Burla",
        "Charamal",
        "Dhama",
        "Dhanupali",
        "Govindpur",
        "Hirakud",
        "Jamankira",
        "Jujomura",
        "Katarbaga",
        "Kisinda",
        "Kochinda",
        "Mahulpalli",
        "Manamunda",
        "Naktideul",
        "Rairakhol",
        "Rengali",
        "Sadar",
        "Sambalpur (m)",
        "Sasan",
        "Thelkoloi"
    ],
    "Kendrapara": [
        "Aali",
        "Derabish",
        "Harichadanpur",
        "Jamboo Marine",
        "Kendrapara",
        "Kendrapara Sadar",
        "Mahakalapada",
        "Marsaghai",
        "Nikirai",
        "Patkura",
        "Pattamundai",
        "Rajkanika",
        "Rajnagar"
    ],
    "Khordha": [
        "Airfield (kapila Prasad)",
        "Balianta",
        "Balipatna",
        "Balugaon",
        "Banapur",
        "Begunia",
        "Bhubaneswar (m Corp.)",
        "Bolagad",
        "Chandaka",
        "Jankia",
        "Jatani",
        "Khandagiri",
        "Khordha",
        "Khordha Sadar",
        "Lingaraj",
        "Mancheswar",
        "Nandankanan",
        "Nirakarpur",
        "Saheednagar",
        "Tamando",
        "Tangi",
        "Uttara P.s"
    ],
    "Koraput": [
        "Bandhugaon",
        "Bhairabsingipur",
        "Boipariguda",
        "Boriguma",
        "Damanjodi",
        "Damonjodi",
        "Dasamantapur",
        "Jeypore",
        "Jeypur",
        "Kakiriguma",
        "Koraput",
        "Koraput Town",
        "Kotiya",
        "Kotpad",
        "Kundura",
        "Lakshmipur",
        "Machh Kund",
        "Nandapur",
        "Narayanpatana",
        "Padua",
        "Pottangi",
        "Similiguda",
        "Sunabeda"
    ],
    "Malkangiri": [
        "Chitrakonda",
        "Jodamba",
        "Kalimela",
        "M.v. 79",
        "Malkangiri",
        "Mathili",
        "Motu",
        "Mudulipada",
        "Orkel",
        "Paparmetla",
        "Podia"
    ],
    "Nabarangpur": [
        "Athagad",
        "Badamba",
        "Baidyeswar",
        "Banki",
        "Barang",
        "C.r.r.i.",
        "Choudwar",
        "Cuttack (m.corp.) P.s",
        "Cuttack Sadar",
        "Gobindpur",
        "Gurudijhatia",
        "Jagatpur",
        "Kandarpur",
        "Kanpur",
        "Khuntuni",
        "Kishannagar",
        "Mahanga",
        "Narasinghpur",
        "Nemalo",
        "Niali",
        "Nischintakoili",
        "Olatapur",
        "Salepur",
        "Tangi",
        "Tigiria"
    ],
    "Nayagarh": [
        "Banigochha",
        "Bhapur",
        "Dasapalla",
        "Fategarh",
        "Gania",
        "Itamati",
        "Khandapada",
        "Nayagarh",
        "Nayagarh Sadar",
        "Nuagaon",
        "Odagaon",
        "Ranapur",
        "Sarankul"
    ],
    "Nuapada": [
        "Boden",
        "Jonk",
        "Khariar",
        "Komana",
        "Komna",
        "Nuapada",
        "Sinapali"
    ],
    "Puri": [
        "Astaranga",
        "Brahmagiri",
        "Chandanpur",
        "Delanga",
        "Gadisagada",
        "Gop",
        "Kakatpur",
        "Konark",
        "Krushna Prasad",
        "Nimapada",
        "Pipili",
        "Puri (m)",
        "Ramachandi",
        "Sadar",
        "Satyabadi"
    ],
    "Rayagada": [
        "Adva",
        "Garabandha",
        "Gurandi",
        "Kashinagara",
        "Mohana",
        "Parlakhemundi",
        "R.udaygiri",
        "Ramagiri",
        "Rayagada",
        "Serango"
    ],
    "Sambalpur": [
        "Ainthapali",
        "Burla",
        "Charamal",
        "Dhama",
        "Dhanupali",
        "Govindpur",
        "Hirakud",
        "Jamankira",
        "Jujomura",
        "Katarbaga",
        "Kisinda",
        "Kochinda",
        "Mahulpalli",
        "Manamunda",
        "Naktideul",
        "Rairakhol",
        "Rengali",
        "Sadar",
        "Sambalpur (m)",
        "Sasan",
        "Thelkoloi"
    ],
    "Sundargarh": [
        "Banei",
        "Banki",
        "Baragaon",
        "Bhasma",
        "Biramitrapur",
        "Bisra",
        "Bondamunda",
        "Brahmani Tarang",
        "Chandiposh",
        "Dharuadihi",
        "Gurundia",
        "Hatibari",
        "Hemgir",
        "Kamarposh Balang",
        "Kinjirkela",
        "Koida",
        "Kuarmunda",
        "Kutra",
        "Lahunipara",
        "Lathikata",
        "Lephripara",
        "Mahulapada",
        "Mahulpada",
        "Nuagaon",
        "Raghunathapali",
        "Raiboga",
        "Rajagangapur",
        "Raurkela (its)p.s.",
        "Raurkela (m)",
        "Sundargarh",
        "Sundargarh Town",
        "Talasara",
        "Tangarapali",
        "Tikaetpali"
    ],
    "Karaikal": [
        "Karaikal Taluk",
        "Kottucherry Commune Panchayat",
        "Nedungadu Commune Panchayat",
        "Neravy Commune Panchayat",
        "Thirumalairayan Pattinam Commune Panchayat",
        "Thirunallar Taluk"
    ],
    "Mahe": [
        "Mahe Taluk"
    ],
    "Yanam": [
        "Yanam Taluk"
    ],
    "Amritsar": [
        "ATTARI",
        "Ajnala",
        "Amritsar -i",
        "Amritsar- Ii",
        "Baba Bakala",
        "Khadur Sahib",
        "Majitha",
        "Patti",
        "Tarn-Taran"
    ],
    "Barnala": [
        "Ahmedgarh",
        "Barnala",
        "Bhawanigarh",
        "Channo",
        "Dhuri",
        "Dirba",
        "Lehra",
        "Lehragagga",
        "Malerkotla",
        "Moonak",
        "Sangrur",
        "Sunam",
        "Tapa"
    ],
    "Bathinda": [
        "Bathinda",
        "Maur Mandi",
        "Raman",
        "Rampura Phul",
        "Talwandi Sabo"
    ],
    "Faridkot": [
        "Faridkot",
        "Jaitu",
        "Kot Kapura"
    ],
    "Fatehgarh Sahib": [
        "Amloh",
        "Bassi Pathana",
        "Fatehgarh Sahib",
        "Khamanon",
        "Srihind"
    ],
    "Fazilka": [
        "Abohar",
        "Fazilka",
        "Firozpur",
        "Guru Harsahai",
        "Jalalabad",
        "Makhu",
        "Talwandi Bhai",
        "Zira"
    ],
    "Gurdaspur": [
        "Batala",
        "Dera Baba Nanak",
        "Dhar Kalan",
        "Dhariwal",
        "Dinanagar",
        "Gurdaspur",
        "Pathankot"
    ],
    "Hoshiarpur": [
        "Bhunga",
        "Dasua",
        "Garhshankar",
        "Hoshiarpur",
        "Mukerian",
        "Tanda"
    ],
    "Jalandhar": [
        "Adampur",
        "Bhogpur",
        "Jalandhar - I",
        "Jalandhar - II",
        "Kartarpur",
        "Nakodar",
        "Phillaur",
        "Shahkot"
    ],
    "Kapurthala": [
        "Bhulath",
        "Kapurthala",
        "Phagwara",
        "Sultanpur Lodhi"
    ],
    "Ludhiana": [
        "Haibowal",
        "Jagraon",
        "Khanna",
        "Lehra",
        "Ludhiana (east)",
        "Ludhiana (west)",
        "Machhiwara",
        "Maloud",
        "Payal",
        "Raikot",
        "Sahnewal",
        "Samrala"
    ],
    "Mansa": [
        "Bhikhi",
        "Budhlada",
        "Mansa",
        "Sardulgarh"
    ],
    "Moga": [
        "Bagha Purana",
        "Bilaspur",
        "Dharamkot",
        "Moga",
        "Nihal Singhwala"
    ],
    "Muktsar": [
        "Gidderbaha",
        "Lambi",
        "Malout",
        "Muktsar"
    ],
    "Nawanshahr (Shahid Bhagat Singh Nagar)": [
        "Balachaur",
        "Banga",
        "Nawanshahr"
    ],
    "Pathankot": [
        "Batala",
        "Dera Baba Nanak",
        "Dhar Kalan",
        "Dhariwal",
        "Dinanagar",
        "Gurdaspur",
        "Pathankot"
    ],
    "Patiala": [
        "Amargarh",
        "Dera Bassi",
        "Ghanaur",
        "Kakrala Bhaika",
        "Nabha",
        "Patiala",
        "Patran",
        "Rajpura",
        "Samana"
    ],
    "Rupnagar": [
        "Anandpur Sahib",
        "Chamkaur Sahib",
        "Chamkur",
        "Kharar",
        "Morinda",
        "Nangal",
        "Rupnagar",
        "S.A.S.Nagar (Mohali)"
    ],
    "Sahibzada Ajit Singh Nagar (Mohali)": [
        "Dera Bassi",
        "Kharar",
        "Lalru",
        "Landran",
        "Majri",
        "Mohali",
        "Sahibzada Ajit Singh Nagar"
    ],
    "Sangrur": [
        "Ahmedgarh",
        "Barnala",
        "Bhawanigarh",
        "Channo",
        "Dhuri",
        "Dirba",
        "Lehra",
        "Lehragagga",
        "Malerkotla",
        "Moonak",
        "Sangrur",
        "Sunam",
        "Tapa"
    ],
    "Tarn Taran": [
        "ATTARI",
        "Ajnala",
        "Amritsar -i",
        "Amritsar- Ii",
        "Baba Bakala",
        "Khadur Sahib",
        "Majitha",
        "Patti",
        "Tarn-Taran"
    ],
    "Ajmer": [
        "Ajmer",
        "Beawar",
        "Bhinay",
        "Bijainagar",
        "Kekri",
        "Kishangarh",
        "Masuda",
        "Nasirabad",
        "Peesangan",
        "Pushkar",
        "Roopangarh",
        "Sarwar"
    ],
    "Alwar": [
        "Alwar",
        "Bansur",
        "Behror",
        "Bhiwadi",
        "Govindgarh",
        "Kathumar",
        "Kherli",
        "Kishangarh Bas",
        "Kotkasim",
        "Lachhmangarh",
        "Laxmangarh",
        "Malakhera",
        "Mandawar",
        "Neemrana",
        "Nogaon",
        "Rajgarh",
        "Ramgarh",
        "Reni",
        "Tapukra",
        "Thanagazi",
        "Tijara",
        "Umren",
        "khairthal"
    ],
    "Banswara": [
        "Anandpuri",
        "Bagidora",
        "Banswara",
        "Garhi",
        "Ghatol",
        "Kushalgarh"
    ],
    "Baran": [
        "Antah",
        "Atru",
        "Baran",
        "Chhabra",
        "Chhipabarod",
        "Kishanganj",
        "Mangrol",
        "Shahbad"
    ],
    "Barmer": [
        "Balotra",
        "Barmer",
        "Baytoo",
        "Chohtan",
        "Dhorimana",
        "Gida",
        "Gudha Malani",
        "Pachpadra",
        "Ramsar",
        "Samdari",
        "Sedwa",
        "Sheo",
        "Siwana"
    ],
    "Bharatpur": [
        "Bayana",
        "Bharatpur",
        "Deeg",
        "Kaman",
        "Kumher",
        "Nadbai",
        "Nagar",
        "Pahari",
        "Rupbas",
        "Uchain",
        "Weir"
    ],
    "Bhilwara": [
        "Asind",
        "Badnor",
        "Banera",
        "Beejoliya",
        "Bhilwara",
        "Hurda",
        "Jahazpur",
        "Kotri",
        "Mandal",
        "Mandalgarh",
        "Raipur",
        "Sahara",
        "Shahpura"
    ],
    "Bikaner": [
        "Bikaner",
        "Chhatargarh",
        "Dungargarh",
        "Khajuwala",
        "Kolayat",
        "Lunkaransar",
        "Nokha",
        "Poogal",
        "Sridungargarh"
    ],
    "Bundi": [
        "Bundi",
        "Hindoli",
        "Indragarh",
        "Keshoraipatan",
        "Nainwa",
        "Talera"
    ],
    "Churu": [
        "Churu",
        "Rajgarh",
        "Ratangarh",
        "Sardarshahar",
        "Sujangarh",
        "Taranagar"
    ],
    "Dausa": [
        "Bandikui",
        "Baswa",
        "Dausa",
        "Lalsot",
        "Lawan",
        "Mahwa",
        "Mandawar",
        "Sikrai"
    ],
    "Dungarpur": [
        "Aspur",
        "Bichhiwara",
        "Chikhali",
        "Dungarpur",
        "Sagwara",
        "Simalwara"
    ],
    "Hanumangarh": [
        "Ada",
        "Bhadra",
        "Hanumangarh",
        "Nohar",
        "Pilibanga",
        "Rawatsar",
        "Sangaria",
        "Tibi"
    ],
    "Jaipur": [
        "Amarsar",
        "Amber",
        "Bassi",
        "Bhankrota",
        "Chaksu",
        "Chomu",
        "Dudu",
        "Govindgarh",
        "Jaipur",
        "Jaitpura",
        "Jamwa Ramgarh",
        "Khandela",
        "Kishangarh Renwal",
        "Kotputli",
        "Manoharpur",
        "Mauzamabad",
        "Niwai",
        "Phagi",
        "Phulera (hq.sambhar)",
        "Puhlera",
        "Sanganer",
        "Shahpura",
        "Viratnagar"
    ],
    "Jaisalmer": [
        "Bhaniyana",
        "Fatehgarh",
        "Jaisalmer",
        "Pokaran",
        "Sam"
    ],
    "Jalore": [
        "Ahore",
        "Bagora",
        "Bhinmal",
        "Chitalwana",
        "Jalor",
        "Jaswantpura",
        "Raniwara",
        "Sanchore",
        "Sayla"
    ],
    "Jhunjhunu": [
        "Buhana",
        "Chirawa",
        "Jhunjhunun",
        "Khetri",
        "Malsisar",
        "Nawalgarh",
        "Paḻaṉi",
        "Surajgarh",
        "Udaipurwati"
    ],
    "Jodhpur": [
        "Balesar",
        "Baori",
        "Bap",
        "Bechu",
        "Bhopalgarh",
        "Bilara",
        "Jodhpur",
        "Lohawat",
        "Luni",
        "Mandor",
        "Osian",
        "Phalodi",
        "Piparcity",
        "Ramgarh",
        "Shergarh",
        "Trori"
    ],
    "Karauli": [
        "Hindaun",
        "Karauli",
        "Mandrail",
        "Masalpur",
        "Nadoti",
        "Sapotra",
        "Todabhim"
    ],
    "Kota": [
        "Digod",
        "Kota",
        "Ladpura",
        "Pipalda",
        "Ramganj Mandi",
        "Sangod"
    ],
    "Nagaur": [
        "Degana",
        "Didwana",
        "Jayal",
        "Kheenvsar",
        "Kuchaman",
        "Ladnu",
        "Makrana",
        "Merta",
        "Mundwa",
        "Nagaur",
        "Nawa",
        "Parbatsar",
        "Riyan badi"
    ],
    "Pali": [
        "Bali",
        "Desuri",
        "Jaitaran",
        "Khinwara",
        "Marwar Junction",
        "Pali",
        "Raipur",
        "Rani Gaon",
        "Rohat",
        "Sojat",
        "Sumerpur"
    ],
    "Pratapgarh": [
        "Arnod",
        "Chhoti Sadri",
        "Dhariawad",
        "Kunda",
        "Lalganj",
        "Patti",
        "Peepalkhoont",
        "Pratapgarh",
        "Raniganj"
    ],
    "Rajsamand": [
        "Amet",
        "Bhim",
        "Deogarh",
        "Kankroli",
        "Khamnor",
        "Kumbhalgarh",
        "Nathdwara",
        "Railmagra",
        "Rajsamand"
    ],
    "Sawai Madhopur": [
        "Bamanwas",
        "Bonli",
        "Chauth Ka Barwara",
        "Gangapur",
        "Khandar",
        "Malarna Doongar",
        "Sawai Madhopur",
        "Wazripur"
    ],
    "Sikar": [
        "Ajeetgarh",
        "Danta Ramgarh",
        "Dhod",
        "Fatehpur",
        "Khandela",
        "Khatu",
        "Lachhmangarh",
        "Losal",
        "Neem-ka-thana",
        "Ratangarh",
        "Sikar",
        "Sri Madhopur"
    ],
    "Sirohi": [
        "Abu Road",
        "Pindwara",
        "Reodar",
        "Sheoganj",
        "Sirohi"
    ],
    "Sri Ganganagar": [
        "Anupgarh",
        "Mandi Gharsana",
        "Raisinghnagar",
        "Rawla Mandi",
        "Sdulshahr",
        "Sri Ganganagar",
        "Sri Karanpur",
        "Sri Vijaynagar",
        "suratgarh"
    ],
    "Tonk": [
        "Deoli",
        "Malpura",
        "Niwai",
        "Peeplu",
        "Todaraisingh",
        "Tonk",
        "Uniara"
    ],
    "Udaipur": [
        "Bargaon",
        "Bhinder",
        "Girwa",
        "Gogunda",
        "Jhadol",
        "Kherwara",
        "Kotra",
        "Lasadiya",
        "Mavli",
        "Rishabhdeo",
        "Salumbar",
        "Sarada",
        "Udaipur",
        "Vallabhnagar"
    ],
    "Ariyalur": [
        "Ariyalur",
        "Sendurai",
        "Udayarpalayam"
    ],
    "Chennai": [
        "Chennai",
        "Tambaram"
    ],
    "Coimbatore": [
        "Avanashi",
        "Coimbatore North",
        "Coimbatore South",
        "Mettupalayam",
        "Palladam",
        "Pollachi",
        "Sulur",
        "Tiruppur",
        "Udumalaipettai",
        "Valparai"
    ],
    "Cuddalore": [
        "Chidambaram",
        "Cuddalore",
        "Kattumannarkoil",
        "Kurinjipadi",
        "Neyveli",
        "Panruti",
        "Tittakudi",
        "Virudhachalam"
    ],
    "Dharmapuri": [
        "Denkanikottai",
        "Dharmapuri",
        "Harur",
        "Hosur",
        "Krishnagiri",
        "Nallampalli",
        "Palakkodu",
        "Pappireddipatti",
        "Pennagaram",
        "Pochampalli",
        "Uthangarai"
    ],
    "Dindigul": [
        "Attur",
        "Dindigul",
        "Kodaikanal",
        "Natham",
        "Nilakkottai",
        "Oddanchatram",
        "Palani",
        "Vedasandur"
    ],
    "Erode": [
        "Bhavani",
        "Dharapuram",
        "Erode",
        "Gobichettipalayam",
        "Kangeyam",
        "Perundurai",
        "Sathyamangalam",
        "Talavadi"
    ],
    "Karur": [
        "Aravakurichi",
        "Kadavur",
        "Karur",
        "Krishnarayapuram",
        "Kulithalai",
        "Pugalur"
    ],
    "Krishnagiri": [
        "Denkanikottai",
        "Dharmapuri",
        "Harur",
        "Hosur",
        "Krishnagiri",
        "Nallampalli",
        "Palakkodu",
        "Pappireddipatti",
        "Pennagaram",
        "Pochampalli",
        "Uthangarai"
    ],
    "Madurai": [
        "Devakottai",
        "Ilayangudi",
        "Karaikkudi",
        "Manamadurai",
        "Sivaganga",
        "Tirupathur"
    ],
    "Nagapattinam": [
        "Kilvelur",
        "Kuthalam",
        "Mayiladuthurai",
        "Nagapattinam",
        "Sirkali",
        "Tharangambadi",
        "Thirukkuvalai",
        "Vedaranyam"
    ],
    "Namakkal": [
        "Namakkal",
        "Paramathi-velur",
        "Rasipuram",
        "Tiruchengode"
    ],
    "Perambalur": [
        "Kunnam",
        "Perambalur",
        "Veppanthattai"
    ],
    "Pudukkottai": [
        "Alangudi",
        "Aranthangi",
        "Avudayarkoil",
        "Gandarvakkottai",
        "Iluppur",
        "Karambakudi",
        "Kulathur",
        "Manamelkudi",
        "Ponnamaravathi",
        "Pudukkottai",
        "Thirumayam"
    ],
    "Ramanathapuram": [
        "Kadaladi",
        "Kamuthi",
        "Mudukulathur",
        "Paramakudi",
        "Ramanathapuram",
        "Rameswaram",
        "Tiruvadanai"
    ],
    "Salem": [
        "Attur",
        "Edappadi",
        "Gangavalli",
        "Mettur",
        "Omalur",
        "Salem",
        "Sankari",
        "Vazhapadi",
        "Yercaud"
    ],
    "Sivaganga": [
        "Devakottai",
        "Ilayangudi",
        "Karaikkudi",
        "Manamadurai",
        "Sivaganga",
        "Tirupathur"
    ],
    "Thanjavur": [
        "Kumbakonam",
        "Orathanadu",
        "Papanasam",
        "Pattukkottai",
        "Peravurani",
        "Thanjavur",
        "Thiruvaiyaru",
        "Thiruvidaimarudur"
    ],
    "Theni": [
        "Andipatti",
        "Bodinayakanur",
        "Periyakulam",
        "Theni",
        "Uthamapalayam"
    ],
    "Thoothukudi (Tuticorin)": [
        "Kovilpatti",
        "Tuticorin"
    ],
    "Tiruchirappalli": [
        "Lalgudi",
        "Manachanallur",
        "Manapparai",
        "Musiri",
        "Srirangam",
        "Thiruverumbur",
        "Thottiyam",
        "Thuraiyur",
        "Tiruchirappalli"
    ],
    "Tirunelveli": [
        "Alangulam",
        "Ambasamudram",
        "Nanguneri",
        "Palayamkottai",
        "Radhapuram",
        "Sankarankoil",
        "Shenkottai",
        "Sivagiri",
        "Tenkasi",
        "Tirunelveli",
        "Veerakeralamputhur"
    ],
    "Tiruppur": [
        "Avanashi",
        "Coimbatore North",
        "Coimbatore South",
        "Mettupalayam",
        "Palladam",
        "Pollachi",
        "Sulur",
        "Tiruppur",
        "Udumalaipettai",
        "Valparai"
    ],
    "Tiruvannamalai": [
        "Arani",
        "Chengam",
        "Cheyyar",
        "Kallakurichi",
        "Polur",
        "Thandrampet",
        "Tiruvannamalai",
        "Vandavasi"
    ],
    "Vellore": [
        "Ambur",
        "Arakonam",
        "Arcot",
        "Gudiyatham",
        "Katpadi",
        "Tirupathur",
        "Vaniyambadi",
        "Vellore",
        "Wallajah"
    ],
    "Viluppuram": [
        "Gingee",
        "Kallakkurichi",
        "Sankarapuram",
        "Tindivanam",
        "Tirukkoyilur",
        "Ulundurpettai",
        "Vanur",
        "Viluppuram"
    ],
    "Virudhunagar": [
        "Aruppukkottai",
        "Kariapatti",
        "Rajapalayam",
        "Sattur",
        "Sivakasi",
        "Srivilliputhur",
        "Tiruchuli",
        "Virudhunagar"
    ],
    "Adilabad": [
        "Adilabad",
        "Asifabad",
        "Bazarhathnoor",
        "Bejjur",
        "Bela",
        "Bellampalle",
        "Bhainsa",
        "Bhimini",
        "Boath",
        "Chennur",
        "Dahegaon",
        "Dandepalle",
        "Dilawarpur",
        "Gudihathnoor",
        "Ichoda",
        "Inderavelly",
        "Jainad",
        "Jainoor",
        "Jaipur",
        "Jannaram",
        "Kaddam (peddur)",
        "Kagaznagar",
        "Kasipet",
        "Kerameri",
        "Khanapur",
        "Kotapalle",
        "Kouthala",
        "Kubeer",
        "Kuntala",
        "Laxmanchanda",
        "Lokeswaram",
        "Luxettipet",
        "Mamda",
        "Mancherial",
        "Mandamarri",
        "Mudhole",
        "Narnoor",
        "Nennal",
        "Neradigonda",
        "Nirmal",
        "Rebbana",
        "Sarangapur",
        "Sirpur",
        "Sirpur (t)",
        "Talamadugu",
        "Tamsi",
        "Tandur",
        "Tanoor",
        "Tiryani",
        "Utnoor",
        "Vemanpalle",
        "Wankdi"
    ],
    "Bhadradri Kothagudem": [
        "Atmakur",
        "Bachannapet",
        "Bhupalpalle",
        "Chennaraopet",
        "Cherial",
        "Chityal",
        "Devaruppula",
        "Dharmasagar",
        "Dornakal",
        "Duggondi",
        "Eturnagaram",
        "Geesugonda",
        "Ghanpur (mulug)",
        "Ghanpur (station)",
        "Govindaraopet",
        "Gudur",
        "Hanamkonda",
        "Hasanparthy",
        "Jangaon",
        "Kesamudram",
        "Khanapur",
        "Kodakandla",
        "Kothagudem",
        "Kuravi",
        "Lingalaghanpur",
        "Maddur",
        "Mahabubabad",
        "Mangapet",
        "Maripeda",
        "Mogullapalle",
        "Mulug",
        "Nallabelly",
        "Narmetta",
        "Narsampet",
        "Narsimhulapet",
        "Nekkonda",
        "Nellikudur",
        "Palakurthi",
        "Parkal",
        "Parvathagiri",
        "Raghunathpalle",
        "Raiparthy",
        "Regonda",
        "Sangam",
        "Shayampet",
        "Tadvai",
        "Thorrur",
        "Venkatapur",
        "Warangal",
        "Wardhannapet",
        "Zaffergadh"
    ],
    "Jagtial": [
        "Bejjanki",
        "Bheemadevarpalle",
        "Boinpalle",
        "Chandurthi",
        "Chigurumamidi",
        "Choppadandi",
        "Dharmapuri",
        "Dharmaram",
        "Elgaid",
        "Elkathurthi",
        "Ellanthakunta",
        "Gambhiraopet",
        "Gangadhara",
        "Gollapalle",
        "Husnabad",
        "Huzurabad",
        "Ibrahimpatnam",
        "Jagtial",
        "Jammikunta",
        "Julapalle",
        "Kamalapur",
        "Kamanpur",
        "Karimnagar",
        "Kataram",
        "Kathlapur",
        "Kodimial",
        "Koheda",
        "Konaraopeta",
        "Koratla",
        "Mahadevpur",
        "Malharrao",
        "Mallapur",
        "Mallial",
        "Manakondur",
        "Manthani",
        "Medipalle",
        "Metpalle",
        "Mustabad",
        "Mutharam (mahadevpur)",
        "Mutharam (manthani)",
        "Odela",
        "Peddapalle",
        "Pegadapalle",
        "Raikal",
        "Ramadugu",
        "Ramagundam",
        "Saidapur",
        "Sarangapur",
        "Shankarapatnam",
        "Sircilla",
        "Srirampur",
        "Sultanabad",
        "Timmapur (lmd Colony)",
        "Veenavanka",
        "Velgatoor",
        "Vemulawada",
        "Yellareddipet"
    ],
    "Jangaon": [
        "Atmakur",
        "Bachannapet",
        "Bhupalpalle",
        "Chennaraopet",
        "Cherial",
        "Chityal",
        "Devaruppula",
        "Dharmasagar",
        "Dornakal",
        "Duggondi",
        "Eturnagaram",
        "Geesugonda",
        "Ghanpur (mulug)",
        "Ghanpur (station)",
        "Govindaraopet",
        "Gudur",
        "Hanamkonda",
        "Hasanparthy",
        "Jangaon",
        "Kesamudram",
        "Khanapur",
        "Kodakandla",
        "Kothagudem",
        "Kuravi",
        "Lingalaghanpur",
        "Maddur",
        "Mahabubabad",
        "Mangapet",
        "Maripeda",
        "Mogullapalle",
        "Mulug",
        "Nallabelly",
        "Narmetta",
        "Narsampet",
        "Narsimhulapet",
        "Nekkonda",
        "Nellikudur",
        "Palakurthi",
        "Parkal",
        "Parvathagiri",
        "Raghunathpalle",
        "Raiparthy",
        "Regonda",
        "Sangam",
        "Shayampet",
        "Tadvai",
        "Thorrur",
        "Venkatapur",
        "Warangal",
        "Wardhannapet",
        "Zaffergadh"
    ],
    "Jogulamba Gadwal": [
        "Achampet",
        "Addakal",
        "Alampur",
        "Amangal",
        "Amrabad",
        "Atmakur",
        "Balanagar",
        "Balmoor",
        "Bhoothpur",
        "Bijinapalle",
        "Bomraspet",
        "Chinnachintakunta",
        "Damaragidda",
        "Devarkadra",
        "Dhanwada",
        "Dharur",
        "Doulathabad",
        "Farooqnagar",
        "Gadwal",
        "Ghanpur",
        "Ghattu",
        "Gopalpeta",
        "Hanwada",
        "Ieej",
        "Itikyal",
        "Jadcherla",
        "Kalwakurthy",
        "Keshampet",
        "Kodair",
        "Kodangal",
        "Koilkonda",
        "Kollapur",
        "Kondurg",
        "Kosgi",
        "Kothakota",
        "Kothur",
        "Lingal",
        "Maddur",
        "Madgul",
        "Maganoor",
        "Mahbubnagar",
        "Makthal",
        "Maldakal",
        "Manopad",
        "Midjil",
        "Nagarkurnool",
        "Narayanpet",
        "Narva",
        "Nawabpet",
        "Pangal",
        "Pebbair",
        "Peddakothapalle",
        "Peddamandadi",
        "Tadoor",
        "Talakondapalle",
        "Telkapalle",
        "Thimmajipet",
        "Uppununthala",
        "Utkoor",
        "Vangoor",
        "Veepangandla",
        "Veldanda",
        "Waddepalle",
        "Wanaparthy"
    ],
    "Kamareddy": [
        "Armur",
        "Balkonda",
        "Banswada",
        "Bheemgal",
        "Bhiknoor",
        "Bichkunda",
        "Birkoor",
        "Bodhan",
        "Dharpalle",
        "Dichpalle",
        "Domakonda",
        "Gandhari",
        "Jakranpalle",
        "Jukkal",
        "Kamareddy",
        "Kammarpalle",
        "Kotgiri",
        "Lingampet",
        "Machareddy",
        "Madnoor",
        "Makloor",
        "Mortad",
        "Nagareddipet",
        "Nandipet",
        "Navipet",
        "Nizamabad",
        "Nizamsagar",
        "Pitlam",
        "Ranjal",
        "Sadasivanagar",
        "Sirkonda",
        "Tadwai",
        "Varni",
        "Velpur",
        "Yedpalle",
        "Yellareddy"
    ],
    "Karimnagar": [
        "Bejjanki",
        "Bheemadevarpalle",
        "Boinpalle",
        "Chandurthi",
        "Chigurumamidi",
        "Choppadandi",
        "Dharmapuri",
        "Dharmaram",
        "Elgaid",
        "Elkathurthi",
        "Ellanthakunta",
        "Gambhiraopet",
        "Gangadhara",
        "Gollapalle",
        "Husnabad",
        "Huzurabad",
        "Ibrahimpatnam",
        "Jagtial",
        "Jammikunta",
        "Julapalle",
        "Kamalapur",
        "Kamanpur",
        "Karimnagar",
        "Kataram",
        "Kathlapur",
        "Kodimial",
        "Koheda",
        "Konaraopeta",
        "Koratla",
        "Mahadevpur",
        "Malharrao",
        "Mallapur",
        "Mallial",
        "Manakondur",
        "Manthani",
        "Medipalle",
        "Metpalle",
        "Mustabad",
        "Mutharam (mahadevpur)",
        "Mutharam (manthani)",
        "Odela",
        "Peddapalle",
        "Pegadapalle",
        "Raikal",
        "Ramadugu",
        "Ramagundam",
        "Saidapur",
        "Sarangapur",
        "Shankarapatnam",
        "Sircilla",
        "Srirampur",
        "Sultanabad",
        "Timmapur (lmd Colony)",
        "Veenavanka",
        "Velgatoor",
        "Vemulawada",
        "Yellareddipet"
    ],
    "Khammam": [
        "Aswapuram",
        "Aswaraopeta",
        "Bayyaram",
        "Bhadrachalam",
        "Bonakal",
        "Burgampahad",
        "Chandrugonda",
        "Cherla",
        "Chinthakani",
        "Chintur",
        "Dammapeta",
        "Dummugudem",
        "Enkuru",
        "Garla",
        "Gundala",
        "Julurpad",
        "Kallur",
        "Kamepalle",
        "Khammam (rural)",
        "Khammam (urban)",
        "Konijerla",
        "Kothagudem",
        "Kukunoor",
        "Kunavaram",
        "Kusumanchi",
        "Madhira",
        "Manuguru",
        "Mudigonda",
        "Mulkalapalle",
        "Nelakondapalle",
        "Palwancha",
        "Penuballi",
        "Pinapaka",
        "Sathupalle",
        "Singareni",
        "Tallada",
        "Tekulapalle",
        "Thirumalayapalem",
        "Vararamachandrapuram",
        "Velairpadu",
        "Vemsoor",
        "Venkatapuram",
        "Wazeed",
        "Wyra",
        "Yellandu",
        "Yerrupalem"
    ],
    "Komaram Bheem Asifabad": [
        "Adilabad",
        "Asifabad",
        "Bazarhathnoor",
        "Bejjur",
        "Bela",
        "Bellampalle",
        "Bhainsa",
        "Bhimini",
        "Boath",
        "Chennur",
        "Dahegaon",
        "Dandepalle",
        "Dilawarpur",
        "Gudihathnoor",
        "Ichoda",
        "Inderavelly",
        "Jainad",
        "Jainoor",
        "Jaipur",
        "Jannaram",
        "Kaddam (peddur)",
        "Kagaznagar",
        "Kasipet",
        "Kerameri",
        "Khanapur",
        "Kotapalle",
        "Kouthala",
        "Kubeer",
        "Kuntala",
        "Laxmanchanda",
        "Lokeswaram",
        "Luxettipet",
        "Mamda",
        "Mancherial",
        "Mandamarri",
        "Mudhole",
        "Narnoor",
        "Nennal",
        "Neradigonda",
        "Nirmal",
        "Rebbana",
        "Sarangapur",
        "Sirpur",
        "Sirpur (t)",
        "Talamadugu",
        "Tamsi",
        "Tandur",
        "Tanoor",
        "Tiryani",
        "Utnoor",
        "Vemanpalle",
        "Wankdi"
    ],
    "Mahabubabad": [
        "Atmakur",
        "Bachannapet",
        "Bhupalpalle",
        "Chennaraopet",
        "Cherial",
        "Chityal",
        "Devaruppula",
        "Dharmasagar",
        "Dornakal",
        "Duggondi",
        "Eturnagaram",
        "Geesugonda",
        "Ghanpur (mulug)",
        "Ghanpur (station)",
        "Govindaraopet",
        "Gudur",
        "Hanamkonda",
        "Hasanparthy",
        "Jangaon",
        "Kesamudram",
        "Khanapur",
        "Kodakandla",
        "Kothagudem",
        "Kuravi",
        "Lingalaghanpur",
        "Maddur",
        "Mahabubabad",
        "Mangapet",
        "Maripeda",
        "Mogullapalle",
        "Mulug",
        "Nallabelly",
        "Narmetta",
        "Narsampet",
        "Narsimhulapet",
        "Nekkonda",
        "Nellikudur",
        "Palakurthi",
        "Parkal",
        "Parvathagiri",
        "Raghunathpalle",
        "Raiparthy",
        "Regonda",
        "Sangam",
        "Shayampet",
        "Tadvai",
        "Thorrur",
        "Venkatapur",
        "Warangal",
        "Wardhannapet",
        "Zaffergadh"
    ],
    "Mancherial": [
        "Adilabad",
        "Asifabad",
        "Bazarhathnoor",
        "Bejjur",
        "Bela",
        "Bellampalle",
        "Bhainsa",
        "Bhimini",
        "Boath",
        "Chennur",
        "Dahegaon",
        "Dandepalle",
        "Dilawarpur",
        "Gudihathnoor",
        "Ichoda",
        "Inderavelly",
        "Jainad",
        "Jainoor",
        "Jaipur",
        "Jannaram",
        "Kaddam (peddur)",
        "Kagaznagar",
        "Kasipet",
        "Kerameri",
        "Khanapur",
        "Kotapalle",
        "Kouthala",
        "Kubeer",
        "Kuntala",
        "Laxmanchanda",
        "Lokeswaram",
        "Luxettipet",
        "Mamda",
        "Mancherial",
        "Mandamarri",
        "Mudhole",
        "Narnoor",
        "Nennal",
        "Neradigonda",
        "Nirmal",
        "Rebbana",
        "Sarangapur",
        "Sirpur",
        "Sirpur (t)",
        "Talamadugu",
        "Tamsi",
        "Tandur",
        "Tanoor",
        "Tiryani",
        "Utnoor",
        "Vemanpalle",
        "Wankdi"
    ],
    "Medak": [
        "Alladurg",
        "Andole",
        "Chegunta",
        "Chinnakodur",
        "Doultabad",
        "Dubbak",
        "Gajwel",
        "Hathnoora",
        "Jagdevpur",
        "Jharasangam",
        "Jinnaram",
        "Kalher",
        "Kangti",
        "Kohir",
        "Kondapak",
        "Kondapur",
        "Kowdipalle",
        "Kulcharam",
        "Manoor",
        "Medak",
        "Mirdoddi",
        "Mulug",
        "Munpalle",
        "Nangnoor",
        "Narayankhed",
        "Narsapur",
        "Nyalkal",
        "Papannapet",
        "Patancheru",
        "Pulkal",
        "Raikode",
        "Ramachandrapuram",
        "Ramayampet",
        "Regode",
        "Sadasivpet",
        "Sangareddy",
        "Shankarampet (a)",
        "Shankarampet (r)",
        "Shivampet",
        "Siddipet",
        "Tekmal",
        "Thoguta",
        "Tupran",
        "Wargal",
        "Yeldurthy",
        "Zahirabad"
    ],
    "Medchal": [
        "Balanagar",
        "Bantwaram",
        "Basheerabad",
        "Chevella",
        "Dharur",
        "Doma",
        "Gandeed",
        "Ghatkesar",
        "Hayathnagar",
        "Ibrahimpatnam",
        "Kandukur",
        "Keesara",
        "Kulkacharla",
        "Maheswaram",
        "Malkajgiri",
        "Manchal",
        "Marpalle",
        "Medchal",
        "Moinabad",
        "Mominpet",
        "Nawabpet",
        "Pargi",
        "Peddemul",
        "Pudur",
        "Qutubullapur",
        "Rajendranagar",
        "Saroornagar",
        "Serilingampally",
        "Shabad",
        "Shamirpet",
        "Shamshabad",
        "Shankarpalle",
        "Tandur",
        "Uppal",
        "Vicarabad",
        "Yacharam",
        "Yelal"
    ],
    "Nagarkurnool": [
        "Achampet",
        "Addakal",
        "Alampur",
        "Amangal",
        "Amrabad",
        "Atmakur",
        "Balanagar",
        "Balmoor",
        "Bhoothpur",
        "Bijinapalle",
        "Bomraspet",
        "Chinnachintakunta",
        "Damaragidda",
        "Devarkadra",
        "Dhanwada",
        "Dharur",
        "Doulathabad",
        "Farooqnagar",
        "Gadwal",
        "Ghanpur",
        "Ghattu",
        "Gopalpeta",
        "Hanwada",
        "Ieej",
        "Itikyal",
        "Jadcherla",
        "Kalwakurthy",
        "Keshampet",
        "Kodair",
        "Kodangal",
        "Koilkonda",
        "Kollapur",
        "Kondurg",
        "Kosgi",
        "Kothakota",
        "Kothur",
        "Lingal",
        "Maddur",
        "Madgul",
        "Maganoor",
        "Mahbubnagar",
        "Makthal",
        "Maldakal",
        "Manopad",
        "Midjil",
        "Nagarkurnool",
        "Narayanpet",
        "Narva",
        "Nawabpet",
        "Pangal",
        "Pebbair",
        "Peddakothapalle",
        "Peddamandadi",
        "Tadoor",
        "Talakondapalle",
        "Telkapalle",
        "Thimmajipet",
        "Uppununthala",
        "Utkoor",
        "Vangoor",
        "Veepangandla",
        "Veldanda",
        "Waddepalle",
        "Wanaparthy"
    ],
    "Nalgonda": [
        "Alair",
        "Anumula",
        "Atmakur (m)",
        "Atmakur (s)",
        "Bhongir",
        "Bibinagar",
        "Bommalaramaram",
        "Chandam Pet",
        "Chandur",
        "Chilkur",
        "Chintha Palle",
        "Chityala",
        "Chivvemla",
        "Choutuppal",
        "Dameracherla",
        "Devarakonda",
        "Garide Palle",
        "Gundala",
        "Gundla Palle",
        "Gurrampode",
        "Huzurnagar",
        "Jaji Reddi Gudem",
        "Kangal",
        "Kattangoor",
        "Kethe Palle",
        "Kodad",
        "M.turkapalle",
        "Marriguda",
        "Mattam Palle",
        "Mella Cheruvu",
        "Miryalaguda",
        "Mothey",
        "Mothkur",
        "Munagala",
        "Munugode",
        "Nadigudem",
        "Nakrekal",
        "Nalgonda",
        "Nampalle",
        "Narayanapur",
        "Narketpalle",
        "Neredcherla",
        "Nidamanur",
        "Nuthankal",
        "Pedda Adiserla Palle",
        "Peddavoora",
        "Penpahad",
        "Pochampalle",
        "Rajapet",
        "Ramannapeta",
        "Sali Gouraram",
        "Suryapet",
        "Thipparthi",
        "Thirumalgiri",
        "Thripuraram",
        "Thungathurthi",
        "Valigonda",
        "Vemulapalle",
        "Yadagirigutta"
    ],
    "Nirmal": [
        "Adilabad",
        "Asifabad",
        "Bazarhathnoor",
        "Bejjur",
        "Bela",
        "Bellampalle",
        "Bhainsa",
        "Bhimini",
        "Boath",
        "Chennur",
        "Dahegaon",
        "Dandepalle",
        "Dilawarpur",
        "Gudihathnoor",
        "Ichoda",
        "Inderavelly",
        "Jainad",
        "Jainoor",
        "Jaipur",
        "Jannaram",
        "Kaddam (peddur)",
        "Kagaznagar",
        "Kasipet",
        "Kerameri",
        "Khanapur",
        "Kotapalle",
        "Kouthala",
        "Kubeer",
        "Kuntala",
        "Laxmanchanda",
        "Lokeswaram",
        "Luxettipet",
        "Mamda",
        "Mancherial",
        "Mandamarri",
        "Mudhole",
        "Narnoor",
        "Nennal",
        "Neradigonda",
        "Nirmal",
        "Rebbana",
        "Sarangapur",
        "Sirpur",
        "Sirpur (t)",
        "Talamadugu",
        "Tamsi",
        "Tandur",
        "Tanoor",
        "Tiryani",
        "Utnoor",
        "Vemanpalle",
        "Wankdi"
    ],
    "Nizamabad": [
        "Armur",
        "Balkonda",
        "Banswada",
        "Bheemgal",
        "Bhiknoor",
        "Bichkunda",
        "Birkoor",
        "Bodhan",
        "Dharpalle",
        "Dichpalle",
        "Domakonda",
        "Gandhari",
        "Jakranpalle",
        "Jukkal",
        "Kamareddy",
        "Kammarpalle",
        "Kotgiri",
        "Lingampet",
        "Machareddy",
        "Madnoor",
        "Makloor",
        "Mortad",
        "Nagareddipet",
        "Nandipet",
        "Navipet",
        "Nizamabad",
        "Nizamsagar",
        "Pitlam",
        "Ranjal",
        "Sadasivanagar",
        "Sirkonda",
        "Tadwai",
        "Varni",
        "Velpur",
        "Yedpalle",
        "Yellareddy"
    ],
    "Rajanna Sircilla": [
        "Bejjanki",
        "Bheemadevarpalle",
        "Boinpalle",
        "Chandurthi",
        "Chigurumamidi",
        "Choppadandi",
        "Dharmapuri",
        "Dharmaram",
        "Elgaid",
        "Elkathurthi",
        "Ellanthakunta",
        "Gambhiraopet",
        "Gangadhara",
        "Gollapalle",
        "Husnabad",
        "Huzurabad",
        "Ibrahimpatnam",
        "Jagtial",
        "Jammikunta",
        "Julapalle",
        "Kamalapur",
        "Kamanpur",
        "Karimnagar",
        "Kataram",
        "Kathlapur",
        "Kodimial",
        "Koheda",
        "Konaraopeta",
        "Koratla",
        "Mahadevpur",
        "Malharrao",
        "Mallapur",
        "Mallial",
        "Manakondur",
        "Manthani",
        "Medipalle",
        "Metpalle",
        "Mustabad",
        "Mutharam (mahadevpur)",
        "Mutharam (manthani)",
        "Odela",
        "Peddapalle",
        "Pegadapalle",
        "Raikal",
        "Ramadugu",
        "Ramagundam",
        "Saidapur",
        "Sarangapur",
        "Shankarapatnam",
        "Sircilla",
        "Srirampur",
        "Sultanabad",
        "Timmapur (lmd Colony)",
        "Veenavanka",
        "Velgatoor",
        "Vemulawada",
        "Yellareddipet"
    ],
    "Sangareddy": [
        "Alladurg",
        "Andole",
        "Chegunta",
        "Chinnakodur",
        "Doultabad",
        "Dubbak",
        "Gajwel",
        "Hathnoora",
        "Jagdevpur",
        "Jharasangam",
        "Jinnaram",
        "Kalher",
        "Kangti",
        "Kohir",
        "Kondapak",
        "Kondapur",
        "Kowdipalle",
        "Kulcharam",
        "Manoor",
        "Medak",
        "Mirdoddi",
        "Mulug",
        "Munpalle",
        "Nangnoor",
        "Narayankhed",
        "Narsapur",
        "Nyalkal",
        "Papannapet",
        "Patancheru",
        "Pulkal",
        "Raikode",
        "Ramachandrapuram",
        "Ramayampet",
        "Regode",
        "Sadasivpet",
        "Sangareddy",
        "Shankarampet (a)",
        "Shankarampet (r)",
        "Shivampet",
        "Siddipet",
        "Tekmal",
        "Thoguta",
        "Tupran",
        "Wargal",
        "Yeldurthy",
        "Zahirabad"
    ],
    "Siddipet": [
        "Alladurg",
        "Andole",
        "Chegunta",
        "Chinnakodur",
        "Doultabad",
        "Dubbak",
        "Gajwel",
        "Hathnoora",
        "Jagdevpur",
        "Jharasangam",
        "Jinnaram",
        "Kalher",
        "Kangti",
        "Kohir",
        "Kondapak",
        "Kondapur",
        "Kowdipalle",
        "Kulcharam",
        "Manoor",
        "Medak",
        "Mirdoddi",
        "Mulug",
        "Munpalle",
        "Nangnoor",
        "Narayankhed",
        "Narsapur",
        "Nyalkal",
        "Papannapet",
        "Patancheru",
        "Pulkal",
        "Raikode",
        "Ramachandrapuram",
        "Ramayampet",
        "Regode",
        "Sadasivpet",
        "Sangareddy",
        "Shankarampet (a)",
        "Shankarampet (r)",
        "Shivampet",
        "Siddipet",
        "Tekmal",
        "Thoguta",
        "Tupran",
        "Wargal",
        "Yeldurthy",
        "Zahirabad"
    ],
    "Suryapet": [
        "Alair",
        "Anumula",
        "Atmakur (m)",
        "Atmakur (s)",
        "Bhongir",
        "Bibinagar",
        "Bommalaramaram",
        "Chandam Pet",
        "Chandur",
        "Chilkur",
        "Chintha Palle",
        "Chityala",
        "Chivvemla",
        "Choutuppal",
        "Dameracherla",
        "Devarakonda",
        "Garide Palle",
        "Gundala",
        "Gundla Palle",
        "Gurrampode",
        "Huzurnagar",
        "Jaji Reddi Gudem",
        "Kangal",
        "Kattangoor",
        "Kethe Palle",
        "Kodad",
        "M.turkapalle",
        "Marriguda",
        "Mattam Palle",
        "Mella Cheruvu",
        "Miryalaguda",
        "Mothey",
        "Mothkur",
        "Munagala",
        "Munugode",
        "Nadigudem",
        "Nakrekal",
        "Nalgonda",
        "Nampalle",
        "Narayanapur",
        "Narketpalle",
        "Neredcherla",
        "Nidamanur",
        "Nuthankal",
        "Pedda Adiserla Palle",
        "Peddavoora",
        "Penpahad",
        "Pochampalle",
        "Rajapet",
        "Ramannapeta",
        "Sali Gouraram",
        "Suryapet",
        "Thipparthi",
        "Thirumalgiri",
        "Thripuraram",
        "Thungathurthi",
        "Valigonda",
        "Vemulapalle",
        "Yadagirigutta"
    ],
    "Wanaparthy": [
        "Achampet",
        "Addakal",
        "Alampur",
        "Amangal",
        "Amrabad",
        "Atmakur",
        "Balanagar",
        "Balmoor",
        "Bhoothpur",
        "Bijinapalle",
        "Bomraspet",
        "Chinnachintakunta",
        "Damaragidda",
        "Devarkadra",
        "Dhanwada",
        "Dharur",
        "Doulathabad",
        "Farooqnagar",
        "Gadwal",
        "Ghanpur",
        "Ghattu",
        "Gopalpeta",
        "Hanwada",
        "Ieej",
        "Itikyal",
        "Jadcherla",
        "Kalwakurthy",
        "Keshampet",
        "Kodair",
        "Kodangal",
        "Koilkonda",
        "Kollapur",
        "Kondurg",
        "Kosgi",
        "Kothakota",
        "Kothur",
        "Lingal",
        "Maddur",
        "Madgul",
        "Maganoor",
        "Mahbubnagar",
        "Makthal",
        "Maldakal",
        "Manopad",
        "Midjil",
        "Nagarkurnool",
        "Narayanpet",
        "Narva",
        "Nawabpet",
        "Pangal",
        "Pebbair",
        "Peddakothapalle",
        "Peddamandadi",
        "Tadoor",
        "Talakondapalle",
        "Telkapalle",
        "Thimmajipet",
        "Uppununthala",
        "Utkoor",
        "Vangoor",
        "Veepangandla",
        "Veldanda",
        "Waddepalle",
        "Wanaparthy"
    ],
    "Warangal (Rural)": [
        "Atmakur",
        "Bachannapet",
        "Bhupalpalle",
        "Chennaraopet",
        "Cherial",
        "Chityal",
        "Devaruppula",
        "Dharmasagar",
        "Dornakal",
        "Duggondi",
        "Eturnagaram",
        "Geesugonda",
        "Ghanpur (mulug)",
        "Ghanpur (station)",
        "Govindaraopet",
        "Gudur",
        "Hanamkonda",
        "Hasanparthy",
        "Jangaon",
        "Kesamudram",
        "Khanapur",
        "Kodakandla",
        "Kothagudem",
        "Kuravi",
        "Lingalaghanpur",
        "Maddur",
        "Mahabubabad",
        "Mangapet",
        "Maripeda",
        "Mogullapalle",
        "Mulug",
        "Nallabelly",
        "Narmetta",
        "Narsampet",
        "Narsimhulapet",
        "Nekkonda",
        "Nellikudur",
        "Palakurthi",
        "Parkal",
        "Parvathagiri",
        "Raghunathpalle",
        "Raiparthy",
        "Regonda",
        "Sangam",
        "Shayampet",
        "Tadvai",
        "Thorrur",
        "Venkatapur",
        "Warangal",
        "Wardhannapet",
        "Zaffergadh"
    ],
    "Warangal (Urban)": [
        "Atmakur",
        "Bachannapet",
        "Bhupalpalle",
        "Chennaraopet",
        "Cherial",
        "Chityal",
        "Devaruppula",
        "Dharmasagar",
        "Dornakal",
        "Duggondi",
        "Eturnagaram",
        "Geesugonda",
        "Ghanpur (mulug)",
        "Ghanpur (station)",
        "Govindaraopet",
        "Gudur",
        "Hanamkonda",
        "Hasanparthy",
        "Jangaon",
        "Kesamudram",
        "Khanapur",
        "Kodakandla",
        "Kothagudem",
        "Kuravi",
        "Lingalaghanpur",
        "Maddur",
        "Mahabubabad",
        "Mangapet",
        "Maripeda",
        "Mogullapalle",
        "Mulug",
        "Nallabelly",
        "Narmetta",
        "Narsampet",
        "Narsimhulapet",
        "Nekkonda",
        "Nellikudur",
        "Palakurthi",
        "Parkal",
        "Parvathagiri",
        "Raghunathpalle",
        "Raiparthy",
        "Regonda",
        "Sangam",
        "Shayampet",
        "Tadvai",
        "Thorrur",
        "Venkatapur",
        "Warangal",
        "Wardhannapet",
        "Zaffergadh"
    ],
    "Dhalai": [
        "Ambassa",
        "Chhamanu",
        "Dhalai",
        "Dumburnagar",
        "Manu",
        "Salema"
    ],
    "Khowai": [
        "Bishalgarh",
        "Boxanagar",
        "Dukli",
        "Hezamara",
        "Jampuijala",
        "Jirania",
        "Kalyanpur",
        "Kathalia",
        "Khowai",
        "Mandai",
        "Melaghar",
        "Mohanpur",
        "Mungiakumi",
        "Padmabil",
        "Surajmaninagar",
        "Teliamura",
        "Tulashikhar",
        "West Tripura"
    ],
    "North Tripura": [
        "Damchhara",
        "Dasda",
        "Gournagar",
        "Jampuii Hills",
        "Kadamtala",
        "Kumarghat",
        "North Tripura",
        "Panisagar",
        "Pencharthal"
    ],
    "South Tripura": [
        "Amarpur",
        "Bagafa",
        "Bokafa",
        "Hrishyamukh",
        "Kakraban",
        "Karbuk",
        "Killa",
        "Matarbari",
        "Ompi",
        "Rajnagar",
        "Rupaichhari",
        "Satchand",
        "South Tripura"
    ],
    "West Tripura": [
        "Bishalgarh",
        "Boxanagar",
        "Dukli",
        "Hezamara",
        "Jampuijala",
        "Jirania",
        "Kalyanpur",
        "Kathalia",
        "Khowai",
        "Mandai",
        "Melaghar",
        "Mohanpur",
        "Mungiakumi",
        "Padmabil",
        "Surajmaninagar",
        "Teliamura",
        "Tulashikhar",
        "West Tripura"
    ],
    "Almora": [
        "Almora",
        "Bhanoli",
        "Bhikiasain",
        "Chaukhutiya",
        "Dwarahat",
        "Jainti",
        "Ranikhet",
        "Someshwar",
        "Sult"
    ],
    "Bageshwar": [
        "Bageshwar",
        "Garud",
        "Kanda",
        "Kapkot"
    ],
    "Chamoli": [
        "Chamoli",
        "Gairsain",
        "Joshimath",
        "Karnaprayag",
        "Pokhari",
        "Tharali"
    ],
    "Champawat": [
        "Champawat",
        "Lohaghat",
        "Pati",
        "Poornagiri"
    ],
    "Dehradun": [
        "Chakrata",
        "Dehradun",
        "Doiwala",
        "Kalsi",
        "Rishikesh",
        "Tyuni",
        "Vikas Nagar"
    ],
    "Nainital": [
        "Betalghat",
        "Dhari",
        "Haldwani",
        "Kaladhungi",
        "Kosya Kutauli",
        "Lalkuan",
        "Nainital",
        "Ramgarh",
        "Ramnagar"
    ],
    "Pauri Garhwal": [
        "Kotdwara",
        "Pauri Garhwal"
    ],
    "Pithoragarh": [
        "Berinag",
        "Dharchula",
        "Didihat",
        "Gangolihat",
        "Munsiari",
        "Pithoragarh"
    ],
    "Rudraprayag": [
        "Jakholi*",
        "Rudraprayag",
        "Ukhimath"
    ],
    "Tehri Garhwal": [
        "Devprayag",
        "Dhanaulti",
        "Ghansali",
        "Jakhani Dhar",
        "Narendra Nagar",
        "Pratapnagar",
        "Tehri"
    ],
    "Udham Singh Nagar": [
        "Bazpur",
        "Gadarpur",
        "Jaspur",
        "Kashipur",
        "Khatima",
        "Kichha",
        "Pantnagar",
        "Sitarganj",
        "Sultanpur",
        "Udham Singh Nagar"
    ],
    "Agra": [
        "Agra",
        "Awal",
        "Bah",
        "Etmadpur",
        "Fatehabad",
        "Fatehpur sikri",
        "Kheragarh",
        "Kiraoli"
    ],
    "Aligarh": [
        "Aligarh",
        "Atrauli",
        "Gabhana",
        "Gorai",
        "Iglas",
        "Khair",
        "Koil"
    ],
    "Allahabad": [
        "Allahabad",
        "Bara",
        "Handia",
        "Karchhana",
        "Koraon",
        "Meja",
        "Naini",
        "Phulpur",
        "Shankargarh",
        "Soraon"
    ],
    "Amethi (Chatrapati Sahuji Mahraj Nagar)": [
        "Amethi",
        "Baldirai",
        "Gauriganj",
        "Jaisinghpur",
        "Kadipur",
        "Lambhua",
        "Musafirkhana",
        "Sultanpur"
    ],
    "Amroha (J.P. Nagar)": [
        "Amroha",
        "Dhanaura",
        "Hasanpur"
    ],
    "Auraiya": [
        "Auraiya",
        "Bidhuna",
        "Dibiyapur"
    ],
    "Azamgarh": [
        "Azamgarh",
        "Burhanpur",
        "Lalganj",
        "Martinganj",
        "Mehnagar",
        "Nizamabad",
        "Phulpur",
        "Sadar",
        "Sagri",
        "Tagdi"
    ],
    "Baghpat": [
        "Baghpat",
        "Baraut",
        "Khekada"
    ],
    "Bahraich": [
        "Bahraich",
        "Kaiserganj",
        "Mahasi",
        "Mihinpurwa",
        "Nanpara",
        "Payagpur"
    ],
    "Ballia": [
        "Bairia",
        "Ballia",
        "Bansdih",
        "Belthara Road",
        "Rasra",
        "Sikanderpur"
    ],
    "Banda": [
        "Atarra",
        "Baberu",
        "Banda",
        "Naraini",
        "Pailani"
    ],
    "Barabanki": [
        "BANGAWAN",
        "Barabanki",
        "Fatehpur",
        "Haidergarh",
        "Kaisarganj",
        "Nawabganj",
        "Ramnagar",
        "Ramsanehighat",
        "Sirauli Gauspur"
    ],
    "Bareilly": [
        "Aonla",
        "Baheri",
        "Bareilly",
        "Dohara",
        "Faridpur",
        "Meerganj",
        "Nawabganj"
    ],
    "Basti": [
        "Basti",
        "Bhanpur",
        "Harraiya",
        "Rudhauli"
    ],
    "Bhadohi": [
        "Aurai",
        "Bhadohi",
        "Gyanpur"
    ],
    "Bijnor": [
        "Bijnor",
        "Chandpur",
        "Dhampur",
        "Nagina",
        "Najibabad",
        "Noorpur"
    ],
    "Budaun": [
        "Bilsi",
        "Bisauli",
        "Budaun",
        "Dataganj",
        "Gunnaur",
        "Sahaswan",
        "Ujhani"
    ],
    "Bulandshahr": [
        "Anupshahr",
        "Bulandshahr",
        "Debai",
        "Khurja",
        "Shikarpur",
        "Siana",
        "Sikandrabad"
    ],
    "Chandauli": [
        "Chakia",
        "Chandauli",
        "Mughalsarai",
        "Sakaldiha"
    ],
    "Deoria": [
        "Barhaj",
        "Bhagalpur",
        "Bhatpar Rani",
        "Deoria",
        "Deoria Sadar",
        "Rudrapur",
        "Salempur"
    ],
    "Etah": [
        "Aliganj",
        "Etah",
        "Jalesar",
        "Kartala",
        "Kasganj",
        "Patiyali"
    ],
    "Etawah": [
        "Bharthana",
        "Chakarnagar",
        "Etawah",
        "Jaswantnagar",
        "Saifai",
        "Takha"
    ],
    "Faizabad": [
        "Bikapur",
        "Deokali",
        "Faizabad",
        "Milkipur",
        "Rudauli",
        "Sohawal"
    ],
    "Farrukhabad": [
        "Amritpur",
        "Farrukhabad",
        "Fatehgarh",
        "Kaimganj"
    ],
    "Fatehpur": [
        "Bindki",
        "Fatehpur",
        "Khaga"
    ],
    "Firozabad": [
        "Firozabad",
        "Jasrana",
        "Shikohabad",
        "Sirsaganj",
        "Tundla"
    ],
    "Gautam Buddha Nagar": [
        "Dadri",
        "Dankaur",
        "Gautam Buddha Nagar",
        "Jewar",
        "Sadar"
    ],
    "Ghaziabad": [
        "Garhmukteshwar",
        "Ghaziabad",
        "Hapur",
        "Kavinanger",
        "Loni",
        "Modinagar",
        "Muradnagar"
    ],
    "Ghazipur": [
        "Ghazipur",
        "Jakhania",
        "Jakhanian",
        "Kasimabad",
        "Mohammadabad",
        "Saidpur",
        "Zamania"
    ],
    "Gonda": [
        "Colonelganj",
        "Gonda",
        "Khargupur",
        "Mankapur",
        "Tarabganj"
    ],
    "Gorakhpur": [
        "Bansgaon",
        "Campierganj",
        "Cauriram",
        "Chauri Chaura",
        "Dewariya",
        "Gola",
        "Gorakhpur",
        "Khajni",
        "Sahjanwa"
    ],
    "Hapur (Panchsheel Nagar)": [
        "Garhmukteshwar",
        "Ghaziabad",
        "Hapur",
        "Kavinanger",
        "Loni",
        "Modinagar",
        "Muradnagar"
    ],
    "Hardoi": [
        "Ahirori",
        "Bilgram",
        "Hardoi",
        "Sandila",
        "Sawayajpur",
        "Shahabad"
    ],
    "Hathras": [
        "Hathras",
        "Sadabad",
        "Sasni",
        "Sikandra Rao"
    ],
    "Jalaun": [
        "Jalaun",
        "Kalpi",
        "Konch",
        "Madhogarh",
        "Orai"
    ],
    "Jaunpur": [
        "Badlapur",
        "Jaunpur",
        "Kerakat",
        "Khetasarai",
        "Machhlishahr",
        "Mariahu",
        "Shahganj"
    ],
    "Jhansi": [
        "Chirgaon",
        "Garautha",
        "Gurasrai",
        "Jhansi",
        "Mauranipur",
        "Moth",
        "Tahrauli"
    ],
    "Kannauj": [
        "Chhibramau",
        "Gursahaiganj",
        "Kannauj",
        "Tirwa"
    ],
    "Kanpur Dehat": [
        "Bilhaur",
        "Ghatampur",
        "Kalyanpur",
        "Kanpur",
        "Maharajpur",
        "Narwal"
    ],
    "Kanpur Nagar": [
        "Bilhaur",
        "Ghatampur",
        "Kalyanpur",
        "Kanpur",
        "Maharajpur",
        "Narwal"
    ],
    "Kanshiram Nagar (Kasganj)": [
        "BANGAWAN",
        "Barabanki",
        "Fatehpur",
        "Haidergarh",
        "Kaisarganj",
        "Nawabganj",
        "Ramnagar",
        "Ramsanehighat",
        "Sirauli Gauspur"
    ],
    "Kushinagar (Padrauna)": [
        "Fazilnagar",
        "Hata",
        "Kaptainganj",
        "Kasia",
        "Kasya",
        "Khadda",
        "Kushinagar",
        "Padrauna",
        "Ramkola",
        "Sewarhi",
        "Tamkuhi Raj"
    ],
    "Lakhimpur - Kheri": [
        "Dhaurahara",
        "Gola Gokaran Nath",
        "Lakhimpur",
        "Mohammdi",
        "Nighasan",
        "Palia",
        "Paliakaln"
    ],
    "Lalitpur": [
        "Barda",
        "Lalitpur",
        "Mahroni",
        "Pali",
        "Talbehat"
    ],
    "Lucknow": [
        "Bakshi Ka Talab",
        "Gangaganj",
        "Gomti Nagar",
        "Lucknow",
        "Malihabad",
        "Mohanlalganj",
        "Sarojini Nagar,"
    ],
    "Maharajganj": [
        "Dalmau",
        "Lalganj",
        "Maharajganj",
        "Rae Bareli",
        "Salon",
        "Tiloi",
        "Unchahar"
    ],
    "Mahoba": [
        "Charkhari",
        "Kulpahar",
        "Mahoba",
        "Panwari"
    ],
    "Mainpuri": [
        "Bhogaon",
        "Ghiror",
        "Karhal",
        "Kishni",
        "Kurawali",
        "Mainpuri"
    ],
    "Mathura": [
        "Chhata",
        "Farah",
        "Goverdhan",
        "Kosi Kalan",
        "Mahavan",
        "Mat",
        "Mathura",
        "Surir",
        "Vrindavan"
    ],
    "Mau": [
        "Karwi",
        "Manikpur",
        "Mau",
        "Rajapur"
    ],
    "Meerut": [
        "Hastinapur",
        "Mawana",
        "Meerut",
        "Sardhana"
    ],
    "Mirzapur": [
        "Chunar",
        "Lalganj",
        "Marihan",
        "Mirzapur"
    ],
    "Moradabad": [
        "Bilari",
        "Chandausi",
        "Kanth",
        "Moradabad",
        "Sambhal",
        "Thakurdwara"
    ],
    "Muzaffarnagar": [
        "Budhana",
        "Insaharanpur",
        "Jansath",
        "Kairana",
        "Khatauli",
        "Muraul",
        "Muzaffarnagar",
        "Shamli",
        "Sisauli"
    ],
    "Pilibhit": [
        "Amriya",
        "Bisalpur",
        "Jahanabad",
        "Kalinagar",
        "Pilibhit",
        "Puranpur"
    ],
    "RaeBareli": [
        "Dalmau",
        "Lalganj",
        "Maharajganj",
        "Rae Bareli",
        "Salon",
        "Tiloi",
        "Unchahar"
    ],
    "Rampur": [
        "Bilaspur",
        "Milak",
        "Rampur",
        "Shahabad",
        "Suar",
        "Tanda"
    ],
    "Saharanpur": [
        "Behat",
        "Deoband",
        "Gangoh",
        "Muzaffarabad",
        "Nakur",
        "Nanauta",
        "Rampur Maniharan",
        "Saharanpur",
        "Sarsawa"
    ],
    "Sambhal (Bhim Nagar)": [
        "Bilari",
        "Chandausi",
        "Kanth",
        "Moradabad",
        "Sambhal",
        "Thakurdwara"
    ],
    "Shahjahanpur": [
        "Jalalabad",
        "Kalan",
        "Khutar",
        "Powayan",
        "Sadar",
        "Shahjahanpur",
        "Tilhar"
    ],
    "Sitapur": [
        "Biswan",
        "Laharpur",
        "Mahmudabad",
        "Maholi",
        "Misrikh",
        "Sidhauli",
        "Sitapur"
    ],
    "Sultanpur": [
        "Bangarmau",
        "Bighapur",
        "Hasanganj",
        "Purwa",
        "Safipur",
        "Sultanpur",
        "Unnao"
    ],
    "Unnao": [
        "Bangarmau",
        "Bighapur",
        "Hasanganj",
        "Purwa",
        "Safipur",
        "Sultanpur",
        "Unnao"
    ],
    "Varanasi": [
        "Garthama",
        "Pindra",
        "Rajatalab",
        "Varanasi"
    ],
    "Alipurduar": [
        "Alipurduar - I",
        "Alipurduar - Ii",
        "Dhupguri",
        "Falakata",
        "Jalpaiguri",
        "Kalchini",
        "Kumargram",
        "Madarihat",
        "Mal",
        "Matiali",
        "Maynaguri",
        "Nagrakata",
        "Rajganj"
    ],
    "Bankura": [
        "Bankura - I",
        "Bankura - Ii",
        "Barjora",
        "Chhatna",
        "Gangajalghati",
        "Hirbandh",
        "Indpur",
        "Indus",
        "Jaypur",
        "Khatra",
        "Kotulpur",
        "Manikganj",
        "Mejhia",
        "Onda",
        "Patrasayer",
        "Raipur",
        "Ranibundh",
        "Saltora",
        "Sarenga",
        "Simlapal",
        "Sonamukhi",
        "Taldangra",
        "Vishnupur"
    ],
    "Birbhum": [
        "Birbhum",
        "Bolpur Sriniketan",
        "Dubrajpur",
        "Illambazar",
        "Khoyrasol",
        "Labpur",
        "Mangalpur",
        "Mayureswar - I",
        "Mayureswar - Ii",
        "Mohammad Bazar",
        "Murarai - I",
        "Murarai - Ii",
        "Nalhati - I",
        "Nalhati - Ii",
        "Nanoor",
        "Rajnagar",
        "Rampurhat - I",
        "Rampurhat - Ii",
        "Sainthia",
        "Suri - I",
        "Suri - Ii"
    ],
    "Cooch Behar": [
        "Cooch Behar - I",
        "Cooch Behar - Ii",
        "Dinhata - I",
        "Dinhata - Ii",
        "Haldibari",
        "Koch Bihar",
        "Mathabhanga - I",
        "Mathabhanga - Ii",
        "Mekliganj",
        "Sitai",
        "Sitalkuchi",
        "Tufanganj - I",
        "Tufanganj - Ii"
    ],
    "Dakshin Dinajpur (South Dinajpur)": [
        "Balurghat",
        "Bansihari",
        "Dakshin Dinajpur",
        "Gangarampur",
        "Harirampur",
        "Hilli",
        "Jhargaon",
        "Kumarganj",
        "Kushmundi",
        "Tapan"
    ],
    "Darjeeling": [
        "Darjeeling Pulbazar",
        "Darjiling",
        "Gorubathan",
        "Jorebunglow Sukiapokhri",
        "Kalimpong - Ii",
        "Kalimpong -i",
        "Kharibari",
        "Kurseong",
        "Matigara",
        "Mirik",
        "Naxalbari",
        "Phansidewa",
        "Rangli Rangliot",
        "Siliguri"
    ],
    "Howrah": [
        "Howrah"
    ],
    "Jalpaiguri": [
        "Alipurduar - I",
        "Alipurduar - Ii",
        "Dhupguri",
        "Falakata",
        "Jalpaiguri",
        "Kalchini",
        "Kumargram",
        "Madarihat",
        "Mal",
        "Matiali",
        "Maynaguri",
        "Nagrakata",
        "Rajganj"
    ],
    "Kalimpong": [
        "Darjeeling Pulbazar",
        "Darjiling",
        "Gorubathan",
        "Jorebunglow Sukiapokhri",
        "Kalimpong - Ii",
        "Kalimpong -i",
        "Kharibari",
        "Kurseong",
        "Matigara",
        "Mirik",
        "Naxalbari",
        "Phansidewa",
        "Rangli Rangliot",
        "Siliguri"
    ],
    "Kolkata": [
        "Calcutta",
        "Kolkata"
    ],
    "Malda": [
        "Alipurduar - I",
        "Alipurduar - Ii",
        "Dhupguri",
        "Falakata",
        "Jalpaiguri",
        "Kalchini",
        "Kumargram",
        "Madarihat",
        "Mal",
        "Matiali",
        "Maynaguri",
        "Nagrakata",
        "Rajganj"
    ],
    "Murshidabad": [
        "Beldanga - I",
        "Beldanga - Ii",
        "Berhampore",
        "Bhagawangola - I",
        "Bhagawangola - Ii",
        "Bharatpur - I",
        "Bharatpur - Ii",
        "Burwan",
        "Domkal",
        "Farakka",
        "Hariharpara",
        "Jalangi",
        "Kandi",
        "Khargram",
        "Lalgola",
        "Murshidabad Jiaganj",
        "Nabagram",
        "Nawda",
        "Raghunathganj - I",
        "Raghunathganj - Ii",
        "Raninagar - I",
        "Raninagar - Ii",
        "Sagardighi",
        "Samserganj",
        "Suti - I",
        "Suti - Ii"
    ],
    "Paschim Medinipur (West Medinipur)": [
        "Asansol",
        "Binpur - I",
        "Binpur - Ii",
        "Chandrakona - I",
        "Chandrakona - Ii",
        "Dantan - I",
        "Dantan - Ii",
        "Daspur - I",
        "Daspur - Ii",
        "Debra",
        "Durgapur",
        "Garbeta - I",
        "Garbeta - Ii",
        "Garbeta - Iii",
        "Ghatal",
        "Gopiballavpur - I",
        "Gopiballavpur - Ii",
        "Jamboni",
        "Jhargram",
        "Keshiary",
        "Keshpur",
        "Kharagpur - I",
        "Kharagpur - Ii",
        "Midnapore",
        "Mohanpur",
        "Narayangarh",
        "Nayagram",
        "Paschim Medinipur",
        "Pingla",
        "Sabang",
        "Salbani",
        "Sankrail"
    ],
    "Purba Medinipur (East Medinipur)": [
        "Bhagawanpur - I",
        "Bhagawanpur - Ii",
        "Chandipur",
        "Contai - I",
        "Contai - Iii",
        "Deshopran",
        "Egra - I",
        "Egra - Ii",
        "Haldia",
        "Khejuri - I",
        "Khejuri - Ii",
        "Kolaghat",
        "Mahisadal",
        "Moyna",
        "Nanda Kumar",
        "Nandigram - I",
        "Nandigram - Ii",
        "Panskura",
        "Potashpur - I",
        "Potashpur - Ii",
        "Purba Medinipur",
        "Ramnagar - I",
        "Ramnagar - Ii",
        "Sahid Matangini",
        "Sutahata",
        "Tamluk"
    ],
    "Purulia": [
        "Arsha",
        "Bagmundi",
        "Balarampur",
        "Barabazar",
        "Bundwan",
        "Hura",
        "Jaipur",
        "Jhalda - I",
        "Jhalda - Ii",
        "Kashipur",
        "Manbazar - I",
        "Manbazar - Ii",
        "Neturia",
        "Para",
        "Puncha",
        "Purulia - I",
        "Purulia - Ii",
        "Puruliya",
        "Raghunathpur - I",
        "Raghunathpur - Ii",
        "Santuri"
    ],
    "Uttar Dinajpur (North Dinajpur)": [
        "Chopra",
        "Gangarampur",
        "Goalpokhar - I",
        "Goalpokhar - Ii",
        "Hemtabad",
        "Islampur",
        "Itahar",
        "Kaliaganj",
        "Karandighi",
        "Raiganj",
        "Uttar Dinajpur"
    ],
    "Sangli": [
        "Atpadi",
        "Jat",
        "Kadegaon",
        "Kavathe Mahankal",
        "Khanapur",
        "Miraj",
        "Palus",
        "Shirala",
        "Tasgaon",
        "Walwa"
    ],
    // Enhanced Maharashtra Data
    "Ahilyanagar": ["Akole", "Jamkhed", "Karjat", "Kopargaon", "Nagar", "Nevasa", "Parner", "Pathardi", "Rahata", "Rahuri", "Sangamner", "Shevgaon", "Shrigonda", "Shrirampur"],
    "Chhatrapati Sambhajinagar": ["Aurangabad", "Gangapur", "Kannad", "Khultabad", "Paithan", "Phulambri", "Sillod", "Soegaon", "Vaijapur"],
    "Dharashiv": ["Bhoom", "Kalamb", "Lohara", "Osmanabad", "Paranda", "Tuljapur", "Umarga", "Washi"],
    "Kolhapur": ["Ajara", "Bavda", "Bhudargad", "Chandgad", "Gadhinglaj", "Hatkanangle", "Kagal", "Karvir", "Panhala", "Radhanagari", "Shahuwadi", "Shirol"],
    "Raigad": ["Alibag", "Karjat", "Khalapur", "Mahad", "Mangaon", "Mhasla", "Murud", "Panvel", "Pen", "Poladpur", "Roha", "Shrivardhan", "Sudhagad (Pali)", "Tala", "Uran"],
    "Sindhudurg": ["Devgad", "Dodamarg", "Kankavli", "Kudal", "Malvan", "Sawantwadi", "Vaibhavwadi", "Vengurla"],
    "Buldhana": ["Buldhana", "Chikhli", "Deulgaon Raja", "Jalgaon (Jamod)", "Khamgaon", "Lonar", "Malkapur", "Mehkar", "Motala", "Nandura", "Sangrampur", "Shegaon", "Sindkhed Raja"],
};